import apiStatus from '@/lib/api-status'
import format from '@/lib/formatUtils/format'
import { defineObject } from '@/lib/define/use-define'
import {
  getFromToCldBookDataByCldIdAndOfficeDataObj,
  getSignByCldIdFromPath,
} from '@/lib/api/use-get-data'
import { SetupContext, computed } from '@vue/composition-api'

import { validFullSize } from '@/lib/validation/use-validation'
import moment from 'moment'
import {
  cldBookForAchievementsType,
  cldBookForAchievementsTypeKey,
  cldBookForAchievementsTypeValue,
  MessageToParentsType,
  ResponseAchievementsType,
  AchivementsCldInfoType,
  ResponseVisitAchievementsType,
  DisplayVisitAchievementsType,
  ResponseAchivementsComeTimeAndReturnKey,
  DisplayAchievementsType,
  ResponseAchievementsKasanKeyType,
} from '@/@types/achievements/index'
import { getKindOfRequest } from '@/lib/attendance/utils'
import moji from 'moji'
import {
  ChildOfficeUnitsBillingGroupType,
  OfficeUnitsBillingGroupType,
  ServiceCodeTypeAndAffiliationType,
} from '@/@types/billing/utility'
import { ResponseCldInfoType } from '@/@types/children'
import { OfficeInfoForAchivements } from '@/@types/office'
import sessionStorageUtils from '@/lib/sessionStrage/session-strage-utils'
import { setAchivementsRemarks } from '@/lib/achievements/set-data/'

const JIHATSU = '1'
const HOUDAY = '0'
const HOHOU = '2'

export const handleStrConvertHankakuToZenkaku = (text: string) => {
  text = moji(text)
    .convert('HE', 'ZE')
    .convert('HK', 'ZK')
    .toString()

  return text
}

export const handleKasanKeyObjSet = (props: any, state: any) => {
  // 所属のチェック
  const targetAffiliationObj = defineObject.AFFILIATION_ARRAY.find(
    (data: { [key: string]: string }) => data.value === props.targetAffiliation
  )

  if (targetAffiliationObj) {
    state.targetAffiliationObj = targetAffiliationObj

    switch (state.targetAffiliationObj.value) {
      case JIHATSU:
        state.keyPrefix = 'jihatsu'
        state.snakeKeyPrefix = state.keyPrefix + '_'
        break

      case HOHOU:
        state.keyPrefix = 'visit'
        state.snakeKeyPrefix = state.keyPrefix + '_'
        break
    }

    for (
      let index = 0;
      index < defineObject.ACHIVEMENTS_KASAN_KEY_ARRAY.length;
      index++
    ) {
      switch (state.targetAffiliationObj.value) {
        case JIHATSU:
        case HOHOU:
          state.kasanKeyObj[defineObject.ACHIVEMENTS_KASAN_KEY_ARRAY[index]] =
            defineObject.ACHIVEMENTS_KASAN_KEY_ARRAY[index][0].toUpperCase() +
            defineObject.ACHIVEMENTS_KASAN_KEY_ARRAY[index].slice(1)
          break

        case HOUDAY:
          state.kasanKeyObj[defineObject.ACHIVEMENTS_KASAN_KEY_ARRAY[index]] =
            defineObject.ACHIVEMENTS_KASAN_KEY_ARRAY[index]
          break
      }
    }
  }
}

export const handleResetVisitValue = (noteInfoObject: any) => {
  noteInfoObject.visitFlg = ''
  noteInfoObject.visitKasanFirst = '0'
  noteInfoObject.isVisitMultiple = '0'
  noteInfoObject.visitKasanSpecialArea = '0'
  noteInfoObject.visitKasanWelfare = '0'
  noteInfoObject.visitManager = ''
  noteInfoObject.visitManagerName = ''
  noteInfoObject.visitLeader = ''
  noteInfoObject.visitLeaderName = ''
  noteInfoObject.visitHomeAddition = '0'
  noteInfoObject.visitHomeAdditionStartHour = '00'
  noteInfoObject.visitHomeAdditionStartMinute = '00'
  noteInfoObject.visitHomeAdditionEndHour = '00'
  noteInfoObject.visitHomeAdditionEndMinute = '00'
}

// 現在の所属以外の加算項目を初期化する
export const handleOtherCurrentAffiliationAdditionReset = (
  noteInfoObject: any,
  isVisitKeyCheck = false
) => {
  const targetAffiliationObj = defineObject.AFFILIATION_ARRAY.find(
    (data: { [key: string]: string }) =>
      data.value === noteInfoObject.affiliation
  )

  if (targetAffiliationObj) {
    let keyPrefix = ''

    if (targetAffiliationObj.value === JIHATSU) {
      keyPrefix = 'jihatsu'
    }

    // 対象の加算項目
    // 初期化する所属以外を選別するためのprefix
    const ACHIVEMENTS_KASAN_KEY_ARRAY = defineObject.ACHIVEMENTS_KASAN_KEY_ARRAY

    for (let index = 0; index < ACHIVEMENTS_KASAN_KEY_ARRAY.length; index++) {
      const key = ACHIVEMENTS_KASAN_KEY_ARRAY[index]
      const upperKey =
        ACHIVEMENTS_KASAN_KEY_ARRAY[index][0].toUpperCase() +
        ACHIVEMENTS_KASAN_KEY_ARRAY[index].slice(1)

      const taregetFilterReg = new RegExp(key + '|' + upperKey)

      const taregetKeyReg = new RegExp(
        '^(?!' + keyPrefix + key + '|' + keyPrefix + upperKey + ').*$'
      )

      const taregetTimeKeyReg = new RegExp(
        'StartHour|StartMinute|EndHour|EndMinute'
      )

      let strValueTypeReg: string | RegExp = ''

      switch (key) {
        case 'homeAddition':
        case 'medicalCooperation':
        case 'kasanExtended':
        case 'kasanStrength':
          strValueTypeReg = new RegExp(key + '|' + upperKey)
          break
      }


      Object.keys(noteInfoObject).forEach((objKey: string) => {
        if (!isVisitKeyCheck) {
          if (objKey.match('visit')) return
        }

        if (objKey.match(taregetFilterReg) && objKey.match(taregetKeyReg)) {
          if (objKey.match(taregetTimeKeyReg)) {
            noteInfoObject[objKey] = '00'
          } else if (strValueTypeReg !== '' && objKey.match(strValueTypeReg)) {
            noteInfoObject[objKey] = '0'
          } else {
            noteInfoObject[objKey] = 0
          }
        }
      })
    }
  }
}

export const calculationOfUsageTime = (
  comeTimeHour: string,
  comeTimeMinute: string,
  returnTimeHour: string,
  returnTimeMinute: string
) => {
  const startTimeHour = comeTimeHour
  const startTimeMinute = comeTimeMinute
  const endTimeHour = returnTimeHour
  const endTimeMinute = returnTimeMinute

  const today = new Date()

  const year = today.getFullYear()
  const month = today.getMonth() + 1
  const day = today.getDay()

  const startTime = new Date(
    year,
    month - 1,
    day,
    Number(startTimeHour),
    Number(startTimeMinute)
  )

  const endTime = new Date(
    year,
    month - 1,
    day,
    Number(endTimeHour),
    Number(endTimeMinute)
  )

  const diff = endTime.getTime() - startTime.getTime()
  const diffMinute = Math.floor(diff / (1000 * 60))
  return diffMinute
}

export const handleIsAbsenceAddition2 = (state: any) => {
  let res = false

  const diff = calculationOfUsageTime(
    state.noteParam.dataObject.comeTimeHour,
    state.noteParam.dataObject.comeTimeMinute,
    state.noteParam.dataObject.returnTimeHour,
    state.noteParam.dataObject.returnTimeMinute
  )

  if (
    diff > 0 &&
    diff <= 30 &&
    state.noteParam.dataObject.flg === 1 &&
    state.noteParam.dataObject.affiliation === '0' &&
    state.noteParam.dataObject.alternativeSupport === '0'
  ) {
    res = true
  }

  return res
}

export const handleIsConsultationAddition30Minutes = (
  setKey: string,
  state: any
) => {
  let res = false
  let consultationAdditionKey = ''

  const RegExp = /StartHour|StartMinute|EndHour|EndMinute/g

  if (!RegExp.test(setKey)) return

  consultationAdditionKey = setKey.replace(
    /StartHour|StartMinute|EndHour|EndMinute/g,
    ''
  )

  if (
    defineObject.CONSULTATION_ADDITION_KEY_ARRAY.some(
      (key: string) => key === consultationAdditionKey
    ) &&
    state.noteParam.dataObject[consultationAdditionKey] === 1
  ) {
    const diff = calculationOfUsageTime(
      state.noteParam.dataObject[`${consultationAdditionKey}StartHour`],
      state.noteParam.dataObject[`${consultationAdditionKey}StartMinute`],
      state.noteParam.dataObject[`${consultationAdditionKey}EndHour`],
      state.noteParam.dataObject[`${consultationAdditionKey}EndMinute`]
    )

    if (diff > 0 && diff < 30) {
      res = true
    }
  }

  return res
}

export const handleIsConsultationAdditionAndHomeAdditionDuplicate = (
  setKey: string,
  state: any,
  mode: string
) => {
  let res = false

  const checkKeyArray: string[] = []
  let type = ''
  // 1.家庭連携加算(児発or放デイ)だったら事業所内相談支援加算Ⅰ・Ⅱのいずれかが1になっていたらtrueを返却する
  if (
    defineObject.HOME_ADDITION_KEY_ARRAY.some(
      (key: string) => key === setKey
    ) &&
    state.noteParam.dataObject[setKey] === '1'
  ) {
    checkKeyArray.push(state.keyPrefix + state.kasanKeyObj.consultationAddition)
    checkKeyArray.push(
      state.keyPrefix + state.kasanKeyObj.consultationAddition2
    )
    type = 'home'
  }
  // 2.事業所内相談支援加算Ⅰ・Ⅱ(児発or放デイ)だったら家庭連携加算が1になっていたらtrueを返却する
  else if (
    defineObject.CONSULTATION_ADDITION_KEY_ARRAY.some(
      (key: string) => key === setKey
    ) &&
    state.noteParam.dataObject[setKey] === 1
  ) {
    checkKeyArray.push(state.keyPrefix + state.kasanKeyObj.homeAddition)
    type = 'consultation'
  }

  if (checkKeyArray.length !== 0) {
    checkKeyArray.some((checkKey: string) => {
      if (
        Object.keys(state.noteParam.dataObject).some(
          () =>
            state.noteParam.dataObject[checkKey] === '1' ||
            state.noteParam.dataObject[checkKey] === 1
        )
      ) {
        res = true

        switch (type) {
          case 'home':
            if (mode === 'input') state.noteParam.dataObject[setKey] = '0'

            break

          case 'consultation':
            if (mode === 'input') state.noteParam.dataObject[setKey] = 0
            break
        }

        return true
      }
    })
  }

  return res
}

export const handlePostIsConsultationAddition30Minutes = (state: any) => {
  let res = false

  if (
    state.noteParam.dataObject[
      state.keyPrefix + state.kasanKeyObj.consultationAddition
    ] === 1 &&
    handleIsConsultationAddition30Minutes(
      state.keyPrefix + state.kasanKeyObj.consultationAddition + 'StartHour',
      state
    )
  ) {
    res = true
  } else if (
    state.noteParam.dataObject[
      state.keyPrefix + state.kasanKeyObj.consultationAddition2
    ] === 1 &&
    handleIsConsultationAddition30Minutes(
      state.keyPrefix + state.kasanKeyObj.consultationAddition2 + 'StartHour',
      state
    )
  ) {
    res = true
  }

  return res
}

export const handleIsPostConsultationAdditionAndHomeAdditionDuplicate = (
  state: any
) => {
  let res = false
  if (
    state.noteParam.dataObject[
      state.keyPrefix + state.kasanKeyObj.homeAddition
    ] === '1'
  ) {
    // 事業所内相談支援加算が同日でONになっていないかのチェック
    if (
      handleIsConsultationAdditionAndHomeAdditionDuplicate(
        state.keyPrefix + state.kasanKeyObj.homeAddition,
        state,
        ''
      )
    ) {
      res = true
    }
  } else if (
    state.noteParam.dataObject[
      state.keyPrefix + state.kasanKeyObj.consultationAddition
    ] === 1
  ) {
    // 家庭連携加算が同日でONになっていないかのチェック
    if (
      handleIsConsultationAdditionAndHomeAdditionDuplicate(
        state.keyPrefix + state.kasanKeyObj.homeAddition,
        state,
        ''
      )
    ) {
      res = true
    }
  } else if (
    state.noteParam.dataObject[
      state.keyPrefix + state.kasanKeyObj.consultationAddition2
    ] === 1
  ) {
    // 家庭連携加算が同日でONになっていないかのチェック
    if (
      handleIsConsultationAdditionAndHomeAdditionDuplicate(
        state.keyPrefix + state.kasanKeyObj.homeAddition,
        state,
        ''
      )
    ) {
      res = true
    }
  }

  return res
}

export const handleIsCheckPickAndSendReset = (
  dataObject: cldBookForAchievementsType
) => {
  let res = false
  if (
    dataObject.flg !== 1 &&
    dataObject.flg !== 3 &&
    (dataObject.pick || dataObject.send)
  ) {
    res = true
  }
  return res
}

const handleLastArrayMsgItem = (array: MessageToParentsType[]) => {
  return array[array.length - 1]
}

const getFormatNowTime = () => {
  const today = new Date()
  const nowTime = `${today.getFullYear()}/${(
    '0' +
    (today.getMonth() + 1)
  ).slice(-2)}/${('0' + today.getDate()).slice(-2)} ${(
    '0' + today.getHours()
  ).slice(-2)}:${('0' + today.getMinutes()).slice(-2)}:${(
    '0' + today.getSeconds()
  ).slice(-2)}`
  return nowTime
}

const handleGetAttendanceRequestMsg = (noteInfoObject: { flg: number }) => {
  let attendanceRequestMsg = ''

  const noteInfoObjectForCheck = format.handleObjectKeyFormatSnake(
    JSON.parse(JSON.stringify(noteInfoObject))
  )

  switch (getKindOfRequest(noteInfoObjectForCheck)) {
    case 'reschedule':
      attendanceRequestMsg = '利用時間変更の承認待ち'
      break

    default:
      {
        const attendanceRequestMsgObj = defineObject.ACHIEVEMENTS_MODAL_ATTENDANCE_MSG_ARRAY.find(
          (data: { [key: string]: string | number }) =>
            data.value === noteInfoObject.flg
        )

        attendanceRequestMsg = attendanceRequestMsgObj
          ? String(attendanceRequestMsgObj.label)
          : ''
      }
      break
  }

  return attendanceRequestMsg
}

const handleGetVisitAttendanceRequestMsg = (noteInfoObject: {
  visitFlg: number
}) => {
  let attendanceRequestMsg = ''

  const noteInfoObjectForCheck = format.handleObjectKeyFormatSnake(
    JSON.parse(JSON.stringify(noteInfoObject))
  )

  const attendanceRequestMsgObj = defineObject.ACHIEVEMENTS_VISIT_MODAL_ATTENDANCE_MSG_ARRAY.find(
    (data: { [key: string]: string | number }) =>
      data.value === noteInfoObjectForCheck.visit_flg
  )

  attendanceRequestMsg = attendanceRequestMsgObj
    ? String(attendanceRequestMsgObj.label)
    : ''

  return attendanceRequestMsg
}

const handleIsParentsRequest = (noteObject: cldBookForAchievementsType) => {
  let res = false

  const noteObjectForCheck = format.handleObjectKeyFormatSnake(
    JSON.parse(JSON.stringify(noteObject))
  )

  switch (getKindOfRequest(noteObjectForCheck)) {
    case 'add':
    case 'absence':
    case 'reschedule':
      res = true
      break
  }

  return res
}

const handleIsVisitParentsRequest = (
  noteObject: cldBookForAchievementsType
) => {
  let res = false

  const noteObjectForCheck = format.handleObjectKeyFormatSnake(
    JSON.parse(JSON.stringify(noteObject))
  )

  if (noteObjectForCheck.visit_flg === 2) {
    res = true
  }

  return res
}

const handleSetAutoMessageToParents = (
  noteObject: cldBookForAchievementsType,
  staffName: string
) => {
  const staffAutoMsg = `確認しました。(${staffName})`
  const nowDate = getFormatNowTime()

  let reasonKey:
    | 'reasonForAddTo'
    | `reasonForAbsence`
    | 'reasonForReschedule'
    | '' = ''

  const noteObjectForCheck = format.handleObjectKeyFormatSnake(
    JSON.parse(JSON.stringify(noteObject))
  )

  switch (getKindOfRequest(noteObjectForCheck)) {
    // 追加利用申請
    case 'add':
      reasonKey = 'reasonForAddTo'
      break

    // 欠席・お休み申請
    case 'absence':
      reasonKey = 'reasonForAbsence'
      break

    case 'reschedule':
      // 利用時間変更
      reasonKey = 'reasonForReschedule'
  }

  if (reasonKey) {
    const targetReasonObj = handleLastArrayMsgItem(noteObject[reasonKey])

    if (targetReasonObj) {
      targetReasonObj.staff = staffAutoMsg

      targetReasonObj.time = nowDate

      const reasonKeyUpdateFlg = `${reasonKey}UpdateFlg` as
        | 'reasonForAddToUpdateFlg'
        | `reasonForAbsenceUpdateFlg`
        | 'reasonForRescheduleUpdateFlg'

      noteObject[reasonKeyUpdateFlg] = '1'

      noteObject[reasonKey].splice(-1, 1, targetReasonObj)
    }
  }
}

const handleSetAutoVisitMessageToParents = (
  noteObject: cldBookForAchievementsType,
  staffName: string
) => {
  const staffAutoMsg = `確認しました。(${staffName})`
  const nowDate = getFormatNowTime()

  const noteObjectForCheck = format.handleObjectKeyFormatSnake(
    JSON.parse(JSON.stringify(noteObject))
  )

  const reasonKey = 'visitReasonForAbsence'

  if (noteObjectForCheck.visit_flg === 2) {
    const targetReasonObj = handleLastArrayMsgItem(noteObject[reasonKey])

    if (targetReasonObj) {
      targetReasonObj.staff = staffAutoMsg

      targetReasonObj.time = nowDate

      const reasonKeyUpdateFlg = 'visitReasonForAbsenceUpdateFlg'

      noteObject[reasonKeyUpdateFlg] = '1'

      noteObject[reasonKey].splice(-1, 1, targetReasonObj)
    }
  }
}

export const handlePreSetCldBookForAchievements = (
  state: any,
  targetAffiliation: string,
  targetDay: number,
  targetCldBookData: any,
  isBulkMounted = false
) => {
  if (targetCldBookData !== undefined && targetCldBookData !== null) {
    Object.keys(targetCldBookData).forEach((snakeKey: string) => {
      const camelKey = format.camelCase(snakeKey)
      if (
        targetCldBookData[snakeKey] === undefined ||
        targetCldBookData[snakeKey] === null ||
        (snakeKey !== 'flg' &&
          snakeKey !== 'temporary_attendance' &&
          snakeKey !== 'remarks' &&
          snakeKey !== 'absence_support' &&
          targetCldBookData[snakeKey] === '')
      )
        return

      if (
        snakeKey === 'shared' ||
        snakeKey === 'message' ||
        snakeKey === 'support_other' ||
        snakeKey === 'appearance'
      ) {
        state.noteParam.dataObject[camelKey + 'Text'] =
          targetCldBookData[snakeKey]
      }

      if (snakeKey === 'snack' || snakeKey === 'excretion') {
        state.noteParam.dataObject[camelKey + 'Id'] =
          targetCldBookData[snakeKey]
      }

      if (snakeKey === 'sign_flg' && targetCldBookData[snakeKey] === 1) {
        state.noteParam.dataObject.signPath = targetCldBookData['sign_path']
      }

      if (snakeKey === 'support') {
        if (Array.isArray(targetCldBookData[snakeKey])) {
          targetCldBookData[snakeKey].forEach((e: any) => {
            state.noteParam.dataObject.supportArray.push(Number(e))
          })
        } else {
          state.noteParam.dataObject.supportArray.push(
            Number(targetCldBookData[snakeKey])
          )
        }
      }

      if (snakeKey === 'activity') {
        state.noteParam.dataObject.activityArray = targetCldBookData[snakeKey]
      }

      state.noteParam.dataObject[camelKey] = targetCldBookData[snakeKey]
    })
  }

  // 新規作成時のみ開始と終了を初期セット
  if (
    !state.noteParam.dataObject.id &&
    state.noteParam.dataObject.startTime &&
    !targetCldBookData.copy
  ) {
    state.noteParam.dataObject.comeTimeHour = state.noteParam.dataObject.startTime.split(
      ':'
    )[0]
    state.noteParam.dataObject.comeTimeMinute = state.noteParam.dataObject.startTime.split(
      ':'
    )[1]
  }

  if (
    !state.noteParam.dataObject.id &&
    state.noteParam.dataObject.endTime &&
    !targetCldBookData.copy
  ) {
    state.noteParam.dataObject.returnTimeHour = state.noteParam.dataObject.endTime.split(
      ':'
    )[0]
    state.noteParam.dataObject.returnTimeMinute = state.noteParam.dataObject.endTime.split(
      ':'
    )[1]
  }

  if (
    !state.noteParam.dataObject.id &&
    targetCldBookData &&
    targetCldBookData.attendance_data &&
    !targetCldBookData.copy
  ) {
    if (targetCldBookData.attendance_data.pick_plans_flg !== undefined) {
      state.noteParam.dataObject.pick = Number(
        targetCldBookData.attendance_data.pick_plans_flg
      )
    }

    if (targetCldBookData.attendance_data.send_plans_flg !== undefined) {
      state.noteParam.dataObject.send = Number(
        targetCldBookData.attendance_data.send_plans_flg
      )
    }
  }

  let isCldBookUpdate = true

  // targetAffiliation これから作成しようとしている所属で上書きする
  if (state.noteParam.dataObject.id) {
    switch (targetAffiliation) {
      case '2':
        state.noteParam.dataObject.visitChildFlg = '1'
        break

      case '0':
      case '1':
        if (
          state.noteParam.dataObject.affiliation === '2' ||
          state.noteParam.dataObject.affiliation === targetAffiliation
        ) {
          state.noteParam.dataObject.affiliation = targetAffiliation
        } else {
          isCldBookUpdate = false
        }
        break
    }
  }

  if (!isCldBookUpdate) {
    alert(
      'すでに所属の異なる連絡帳・実績記録が存在しているため、実績を新規作成・編集することはできません。連絡帳または実績記録まとめて作成・編集にて、所属を変更することができます。'
    )
    return false
  }

  // 児童の保訪の利用がOFFになっている保訪は通所の出欠、加算を初期化する
  if (state.noteParam.dataObject.visitChildFlg !== '1') {
    handleResetVisitValue(state.noteParam.dataObject)
  }

  // 児童の保訪のみ場合は通所の出欠、加算を初期化する
  if (state.noteParam.dataObject.affiliation === '2') {
    state.noteParam.dataObject.flg = ''
    state.noteParam.dataObject.temporaryAttendance = ''
    state.noteParam.dataObject.pick = 0
    state.noteParam.dataObject.send = 0

    handleOtherCurrentAffiliationAdditionReset(state.noteParam.dataObject)
  }

  state.noteParam.dataObject.day = Number(targetDay)
  state.noteParam.dataObject.staffId = state.staffId
  state.noteParam.dataObject.businessLastStaffId = state.staffId
  state.noteParam.dataObject.cldBookLastStaffId = state.staffId

  let uncheckSendAndPickAddMsg = ''

  if (targetAffiliation === '2') {
    uncheckSendAndPickAddMsg = '同日の通所サービスの'
  }

  if (handleIsCheckPickAndSendReset(state.noteParam.dataObject)) {
    if (!targetCldBookData.copy && !isBulkMounted) {
      alert(
        `${uncheckSendAndPickAddMsg}出欠が出席(欠席加算Ⅱでない)以外なので送迎の選択が外れます。`
      )
    }

    state.noteParam.dataObject.pick = 0
    state.noteParam.dataObject.send = 0
  }

  if (targetCldBookData && targetCldBookData.copy) {
    delete targetCldBookData.copy
  }

  // 保護者からの申請があるかどうか（通所）
  if (
    (targetAffiliation === '0' || targetAffiliation === '1') &&
    handleIsParentsRequest(state.noteParam.dataObject)
  ) {
    handleSetAutoMessageToParents(state.noteParam.dataObject, state.staffName)
    state.attendanceRequestMsg = handleGetAttendanceRequestMsg(
      state.noteParam.dataObject as { flg: number }
    )
    state.isParentsRequest = true
  }

  // 保護者からの申請があるかどうか（保訪）
  if (
    targetAffiliation === '2' &&
    handleIsVisitParentsRequest(state.noteParam.dataObject)
  ) {
    handleSetAutoVisitMessageToParents(
      state.noteParam.dataObject,
      state.staffName
    )
    state.attendanceRequestMsg = handleGetVisitAttendanceRequestMsg(
      state.noteParam.dataObject as { visitFlg: number }
    )
    state.isParentsRequest = true
  }

  state.isShow = true

  return true
}

export const handleGetFromToCldBookDataByCldId = async (
  state: any,
  targetFromAndTo: string,
  officeId: string,
  cldId: string,
  targetAffiliation: string,
  targetDay: number,
  officeDataObj: object,
  isReBilling = false,
  combinedAffiliation = ''
) => {
  const cldBookPromise = getFromToCldBookDataByCldIdAndOfficeDataObj(
    targetFromAndTo,
    targetFromAndTo,
    officeId,
    cldId,
    combinedAffiliation !== '' && combinedAffiliation !== undefined
      ? combinedAffiliation
      : targetAffiliation,
    officeDataObj,
    isReBilling
  )

  state.isNotUpdateByaffiliationDiff = false

  cldBookPromise
    .then(async (response: any) => {
      if (!response) return (state.isShow = true)
      const isStatus = apiStatus.statusHandring(response.data.meta)
      if (!isStatus) {
        alert(
          'データを正常に取得できませんでした。時間をおいてからやり直してください。'
        )
        state.isShow = true
      }

      if (
        !handlePreSetCldBookForAchievements(
          state,
          targetAffiliation,
          targetDay,
          response.data.data[0]
        )
      ) {
        throw new Error('affiliationDiff')
      }
    })
    .catch((err: any) => {
      switch (err.message) {
        case 'affiliationDiff':
          state.isNotUpdateByaffiliationDiff = true
          break

        default:
          alert(
            'データを正常に取得できませんでした。時間をおいてからやり直してください。'
          )
          break
      }

      state.isShow = true
    })
}

export const handleCurrentJapaneseCalendar = (
  year: number | Date,
  month: number | Date
) => {
  const currentDate = new Date(Number(year), Number(month) - 1)
  const options: { [key: string]: string } = {
    year: 'numeric',
    month: 'long',
  }
  const japaneseDate = new Intl.DateTimeFormat(
    'ja-JP-u-ca-japanese',
    options
  ).format(currentDate)
  return `${japaneseDate}`
}

const handleCalculationOfhomeAddition = (
  homeAdditionStartHour: number | boolean | string,
  homeAdditionStartMinute: number | boolean | string,
  homeAdditionEndHour: number | boolean | string,
  homeAdditionEndMinute: number | boolean | string
): number => {
  const startDate = new Date(
    2020,
    1,
    1,
    Number(homeAdditionStartHour),
    Number(homeAdditionStartMinute),
    0
  )
  const endDate = new Date(
    2020,
    1,
    1,
    Number(homeAdditionEndHour),
    Number(homeAdditionEndMinute),
    0
  )
  const diffTime = endDate.getTime() - startDate.getTime()
  const diffHour = Math.round((diffTime / (1000 * 60 * 60)) * 100) / 100

  const homeAdditionStartHours = diffHour

  return homeAdditionStartHours
}

const handleCalculationOfmedicalCooperation = (
  medicalCooperationStartHour: number | boolean | string,
  medicalCooperationStartMinute: number | boolean | string,
  medicalCooperationEndHour: number | boolean | string,
  medicalCooperationEndMinute: number | boolean | string
) => {
  const startDate = new Date(
    2020,
    1,
    1,
    Number(medicalCooperationStartHour),
    Number(medicalCooperationStartMinute),
    0
  )
  const endDate = new Date(
    2020,
    1,
    1,
    Number(medicalCooperationEndHour),
    Number(medicalCooperationEndMinute),
    0
  )
  const diffTime = endDate.getTime() - startDate.getTime()
  const diffHour = Math.floor(diffTime / (1000 * 60 * 60))

  let medicalCooperationStartHours
  if (diffHour === 0) {
    medicalCooperationStartHours = 1
  } else if (diffHour === 1) {
    medicalCooperationStartHours = 2
  } else {
    medicalCooperationStartHours = 3
  }

  return medicalCooperationStartHours
}

export const handleAchievementsCldInfoSet = (achievementsCldInfo: any) => {
  const displayAchievementsObject: { [key: string]: any } = {
    japaneseCalendar: `${handleCurrentJapaneseCalendar(
      achievementsCldInfo.year,
      achievementsCldInfo.month
    )}分`,
    officeNumber: achievementsCldInfo.office_number,
    officeName: achievementsCldInfo.office_name,
    cityNumber: achievementsCldInfo.city_number,
    contractAmount: achievementsCldInfo.contract_amount, // 契約支給量
    visitContractAmount: achievementsCldInfo.visit_contract_amount, // 保訪の契約支給量
    beneficiaryId: achievementsCldInfo.beneficiary_id, // 受給者証番号
    name:
      achievementsCldInfo.child_last_name +
      achievementsCldInfo.child_first_name,
    childKana:
      achievementsCldInfo.child_last_kana &&
      achievementsCldInfo.child_first_kana
        ? achievementsCldInfo.child_last_kana +
          achievementsCldInfo.child_first_kana
        : '',
    parentName:
      achievementsCldInfo.parents_last_name +
      achievementsCldInfo.parents_first_name,
    parentsKana:
      achievementsCldInfo.parents_last_kana_1 &&
      achievementsCldInfo.parents_first_kana_1
        ? achievementsCldInfo.parents_last_kana_1 +
          achievementsCldInfo.parents_first_kana_1
        : '',
    year: achievementsCldInfo.year,
    month: achievementsCldInfo.month,
  }

  // 通所用
  displayAchievementsObject.totalTransfer = 0 as number

  displayAchievementsObject.totalConsultation = 0 as number
  displayAchievementsObject.totalMedicalCooperation = 0 as number

  // 保育所等訪問
  displayAchievementsObject.totalVisitFlg = 0 as number
  displayAchievementsObject.totalKasanFirstAddition = 0 as number

  // 通所、訪問共通
  displayAchievementsObject.totalAddition = 0 as number

  return displayAchievementsObject
}

export const handleSetVisitAchivementsVisitRemarks = (
  visitVchievements: DisplayVisitAchievementsType
) => {
  let remarks = visitVchievements.remarks
    ? visitVchievements.remarks + '　'
    : ''

  if (visitVchievements.flg === 1) {
    const startTime = handleStrConvertHankakuToZenkaku(
      visitVchievements.come_time_hour +
        ':' +
        visitVchievements.come_time_minute
    ) //支援実施開始
    const endTime = handleStrConvertHankakuToZenkaku(
      visitVchievements.return_time_hour +
        ':' +
        visitVchievements.return_time_minute
    ) //支援実施終了

    remarks = remarks + `支援実施時間：${startTime}〜${endTime}` + '　'

    if (visitVchievements.is_visit_multiple === '1') {
      remarks = remarks + '複数支援あり' + '　'
    }

    if (visitVchievements.kasan_special_area === '1') {
      remarks = remarks + '特別地域加算あり' + '　'
    }

    if (visitVchievements.kasan_welfare === '1') {
      remarks = remarks + '専門職員による支援あり' + '　'
    }

    if (visitVchievements.manager_name) {
      remarks = remarks + '支援担当者：' + visitVchievements.manager_name + '　'
    }
  }
  if (visitVchievements.kasan_first === '1') {
    if (visitVchievements.leader_name) {
      remarks =
        remarks +
        '児童発達管理責任者：' +
        visitVchievements.leader_name +
        '　'
    }
  }

  return remarks
}

export const handleDataSetByVisitAchievements = (
  state: any,
  selectDateAchievements: DisplayVisitAchievementsType[],
  achievementsCldInfo: AchivementsCldInfoType
) => {
  const displayAchievementsArrays: any[] = []
  const todayDay = 23

  const displayAchievementsObject = handleAchievementsCldInfoSet(
    achievementsCldInfo
  )

  selectDateAchievements.forEach(
    (achievements: DisplayVisitAchievementsType) => {
      // 家庭連携加算
      achievements.homeAdditionFlg = false
      if (
        !(
          achievements.home_addition_start_hour === '00' &&
          achievements.home_addition_start_minute === '00' &&
          achievements.home_addition_end_hour === '00' &&
          achievements.home_addition_end_minute === '00'
        )
      ) {
        achievements.homeAdditionStartHours = handleCalculationOfhomeAddition(
          achievements.home_addition_start_hour,
          achievements.home_addition_start_minute,
          achievements.home_addition_end_hour,
          achievements.home_addition_end_minute
        )
        achievements.homeAdditionFlg = true

        displayAchievementsObject.totalAddition++
      }

      if (achievements.flg === 1) {
        displayAchievementsObject.totalVisitFlg++
      }

      if (achievements.flg === 1 && achievements.kasan_first === '1') {
        displayAchievementsObject.totalKasanFirstAddition++
      }

      if (!achievements.week_days) {
        moment.updateLocale('ja', {
          weekdays: [
            '日曜日',
            '月曜日',
            '火曜日',
            '水曜日',
            '木曜日',
            '金曜日',
            '土曜日',
          ],
          weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
        })

        const localeWeekday = String(
          moment(
            `${achievements.year}/${achievements.month}/${achievements.day}`,
            'YYYY/MM/DD'
          ).format('YYYY年MM月DD日(ddd)')
        ).slice(-3)

        achievements['week_days'] = localeWeekday.slice(1).slice(0, -1)
      }

      const visitStartAndEndTimeKey: ResponseAchivementsComeTimeAndReturnKey[] = [
        'come_time_hour',
        'come_time_minute',
        'return_time_hour',
        'return_time_minute',
      ]

      visitStartAndEndTimeKey.forEach(key => {
        if (!achievements[key]) {
          achievements[key] = '00'
        }
      })

      const remarks = handleSetVisitAchivementsVisitRemarks(achievements)

      displayAchievementsArrays.push({
        id: achievements.id,
        year: achievements.year,
        month: achievements.month,
        day: achievements.day,
        week: achievements.week_days,
        homeAdditionFlg: achievements.homeAdditionFlg,
        homeAdditionStartHours: achievements.homeAdditionStartHours,
        kasanFirst: achievements.kasan_first,
        flg: achievements.flg, // 実施、実施キャンセル等
        markFlg: achievements.mark_flg, // 確認印
        markPath: achievements.mark_path, // 確認パス
        officeId: achievements.office_id ? achievements.office_id : '',
        officeNumber: achievements.office_number
          ? achievements.office_number
          : '',
        visitRemarks: remarks, // 備考
      })
    }
  )
  displayAchievementsArrays.sort(
    (firstData, secondData) => firstData.day - secondData.day
  )
  const diff = todayDay - displayAchievementsArrays.length
  for (let i = 0; diff > i; i++) {
    displayAchievementsArrays.push({})
  }

  displayAchievementsObject.displayAchievementsArray = displayAchievementsArrays

  const lastDayOfTheMonth = Number(
    new Date(Number(state.fromYear), Number(state.fromMonth), 0).getDate()
  )

  console.log('選択月の月末日は' + lastDayOfTheMonth + '日')

  if (
    todayDay <= displayAchievementsObject.displayAchievementsArray.length &&
    displayAchievementsObject.displayAchievementsArray.length <
      lastDayOfTheMonth
  ) {
    displayAchievementsObject.displayAchievementsArray.push({})
  }

  return displayAchievementsObject
}



export const handleDataSet = (
  state: any,
  selectDateAchievements: any,
  achievementsCldInfo: AchivementsCldInfoType
) => {
  const displayAchievementsArrays: any[] = []
  const todayDay = 23

  const displayAchievementsObject = handleAchievementsCldInfoSet(
    achievementsCldInfo
  )

  selectDateAchievements.forEach((el: DisplayAchievementsType) => {
    let comeTimeHour = String(el.come_time_hour)
    let comeTimeMinute = String(el.come_time_minute)
    let returnTimeHour = String(el.return_time_hour)
    let returnTimeMinute = String(el.return_time_minute)
    if (comeTimeHour == '0') {
      comeTimeHour = '00'
    }
    if (comeTimeMinute == '0') {
      comeTimeMinute = '00'
    }
    if (returnTimeHour == '0') {
      returnTimeHour = '00'
    }
    if (returnTimeMinute == '0') {
      returnTimeMinute = '00'
    }
    if (el.pick === 1) {
      displayAchievementsObject.totalTransfer++
    }
    if (el.send === 1) {
      displayAchievementsObject.totalTransfer++
    }

    const diff = calculationOfUsageTime(
      comeTimeHour,
      comeTimeMinute,
      returnTimeHour,
      returnTimeMinute
    )

    el.attendanceFlg = el.flg

    // 欠席加算Ⅱ
    if (
      (el.alternative_support === '0' || !el.alternative_support) &&
      el.attendanceFlg === 1 &&
      diff >= 0 &&
      diff <= 30 &&
      el.affiliation === '0'
    ) {
      el.flg = 0
      el.attendanceFlg = 1
    }

    let prefix = ''

    if (el.affiliation === '1') {
      prefix = 'jihatsu_'
    }

    // 家庭連携加算
    el.homeAdditionFlg = false
    if (
      !(
        el[
          (prefix +
            'home_addition_start_hour') as ResponseAchievementsKasanKeyType
        ] === '00' &&
        el[
          (prefix +
            'home_addition_start_minute') as ResponseAchievementsKasanKeyType
        ] === '00' &&
        el[
          (prefix +
            'home_addition_end_hour') as ResponseAchievementsKasanKeyType
        ] === '00' &&
        el[
          (prefix +
            'home_addition_end_minute') as ResponseAchievementsKasanKeyType
        ] === '00'
      )
    ) {
      el.homeAdditionStartHours = handleCalculationOfhomeAddition(
        el[
          (prefix +
            'home_addition_start_hour') as ResponseAchievementsKasanKeyType
        ],
        el[
          (prefix +
            'home_addition_start_minute') as ResponseAchievementsKasanKeyType
        ],
        el[
          (prefix +
            'home_addition_end_hour') as ResponseAchievementsKasanKeyType
        ],
        el[
          (prefix +
            'home_addition_end_minute') as ResponseAchievementsKasanKeyType
        ]
      )
      el.homeAdditionFlg = true

      displayAchievementsObject.totalAddition++
    }

    // 医療連携加算
    if (
      Number(
        el[(prefix + 'medical_cooperation') as ResponseAchievementsKasanKeyType]
      ) === 1
    ) {
      el.medicalCooperationStartHours = handleCalculationOfmedicalCooperation(
        el[
          (prefix +
            'medical_cooperation_start_hour') as ResponseAchievementsKasanKeyType
        ],
        el[
          (prefix +
            'medical_cooperation_start_minute') as ResponseAchievementsKasanKeyType
        ],
        el[
          (prefix +
            'medical_cooperation_end_hour') as ResponseAchievementsKasanKeyType
        ],
        el[
          (prefix +
            'medical_cooperation_end_minute') as ResponseAchievementsKasanKeyType
        ]
      )
      displayAchievementsObject.totalMedicalCooperation++
    }

    // 事業所内相談支援の回数の1日の合計
    let consultationAdditionDayTotal = 0

    if (
      el[(prefix + 'consultation_addition') as ResponseAchievementsKasanKeyType]
    ) {
      consultationAdditionDayTotal++
    }

    if (
      el[
        (prefix + 'consultation_addition2') as ResponseAchievementsKasanKeyType
      ]
    ) {
      consultationAdditionDayTotal++
    }

    // 事業所内相談支援加算
    if (consultationAdditionDayTotal) {
      displayAchievementsObject.totalConsultation += consultationAdditionDayTotal
    }

    el.remarks = setAchivementsRemarks(el.remarks, el)

    if (!el.week_days) {
      moment.updateLocale('ja', {
        weekdays: [
          '日曜日',
          '月曜日',
          '火曜日',
          '水曜日',
          '木曜日',
          '金曜日',
          '土曜日',
        ],
        weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
      })

      const localeWeekday = String(
        moment(`${el.year}/${el.month}/${el.day}`, 'YYYY/MM/DD').format(
          'YYYY年MM月DD日(ddd)'
        )
      ).slice(-3)

      el['week_days'] = localeWeekday.slice(1).slice(0, -1)
    }

    displayAchievementsArrays.push({
      id: el.id,
      year: el.year,
      month: el.month,
      day: el.day,
      week: el.week_days,
      startTime: comeTimeHour + ':' + comeTimeMinute,
      endTime: returnTimeHour + ':' + returnTimeMinute,
      pick: el.pick,
      send: el.send,
      homeAdditionFlg: el.homeAdditionFlg,
      homeAdditionStartHours: el.homeAdditionStartHours,
      flg: el.flg, // サービス提供状況
      attendanceFlg: el.attendanceFlg,
      consultationAddition: consultationAdditionDayTotal
        ? consultationAdditionDayTotal
        : '', // 事業所内相談支援加算
      medicalCooperation: Number(
        el[(prefix + 'medical_cooperation') as ResponseAchievementsKasanKeyType]
      ), // 医療連携体制加算
      medicalCooperationStartHours: el.medicalCooperationStartHours,
      provisionForm: el.provision_form, // 提供形態
      remarks: el.remarks, // 備考
      markFlg: el.mark_flg, // 確認印
      markPath: el.mark_path, // 確認パス
      officeId: el.office_id ? el.office_id : '',
      officeNumber: el.office_number ? el.office_number : '',
    })
  })
  displayAchievementsArrays.sort(
    (firstData, secondData) => firstData.day - secondData.day
  )
  const diff = todayDay - displayAchievementsArrays.length
  for (let i = 0; diff > i; i++) {
    displayAchievementsArrays.push({})
  }

  displayAchievementsObject.displayAchievementsArray = displayAchievementsArrays

  const lastDayOfTheMonth = Number(
    new Date(Number(state.fromYear), Number(state.fromMonth), 0).getDate()
  )

  console.log('選択月の月末日は' + lastDayOfTheMonth + '日')

  if (
    todayDay <= displayAchievementsObject.displayAchievementsArray.length &&
    displayAchievementsObject.displayAchievementsArray.length <
      lastDayOfTheMonth
  ) {
    displayAchievementsObject.displayAchievementsArray.push({})
  }

  return displayAchievementsObject
}

const handleValidIsDeletePatternKasan = (state: any) => {
  let isDeletePattern = false

  if (
    !Number(
      state.noteParam.dataObject[
        state.keyPrefix + state.kasanKeyObj.homeAddition
      ]
    ) &&
    !Number(
      state.noteParam.dataObject[
        state.keyPrefix + state.kasanKeyObj.medicalCooperation
      ]
    ) &&
    !Number(
      state.noteParam.dataObject[
        state.keyPrefix + state.kasanKeyObj.organizationAddition
      ]
    ) &&
    !Number(
      state.noteParam.dataObject[
        state.keyPrefix + state.kasanKeyObj.organizationAddition2
      ]
    ) &&
    !Number(
      state.noteParam.dataObject[
        state.keyPrefix + state.kasanKeyObj.consultationAddition
      ]
    ) &&
    !Number(
      state.noteParam.dataObject[
        state.keyPrefix + state.kasanKeyObj.consultationAddition2
      ]
    ) &&
    !Number(
      state.noteParam.dataObject[
        state.keyPrefix + state.kasanKeyObj.kasanFirst
      ]
    )
  ) {
    isDeletePattern = true
  }

  return isDeletePattern
}

const handleValidIsDeletePatternFlg = (state: any, isVisit = false) => {
  let isDeletePattern = false

  if (isVisit) {
    if (state.noteParam.dataObject.visitFlg !== 1) {
      isDeletePattern = true
    }
  } else {
    if (
      state.noteParam.dataObject.flg !== 0 &&
      state.noteParam.dataObject.flg !== 1
    ) {
      isDeletePattern = true
    }
  }

  return isDeletePattern
}

export const handleValidIsDeletePattern = (state: any, isVisit = false) => {
  let isDeletePattern = false

  if (
    handleValidIsDeletePatternKasan(state) &&
    handleValidIsDeletePatternFlg(state, isVisit)
  ) {
    isDeletePattern = true
  }
  return isDeletePattern
}

export const handleGetSignImg = async (signPath: string, officeId: string) => {
  const response = await getSignByCldIdFromPath(signPath, officeId)

  if (response) {
    const isStatus = apiStatus.statusHandring(response.data.meta)
    if (!isStatus) {
      alert(
        'データを正常に取得できませんでした。時間をおいてからやり直してください。'
      )
      window.history.back()
      return
    }
    if (response.data.meta === '3800') {
      return
    }
    return response.data.data
  }
}

export const handleGetHeight = (state: any, context: SetupContext) => {
  state.heightArray.splice(-state.heightArray.length)

  context.root.$nextTick(() => {
    const tableRow = document.getElementsByClassName('table_row')
    for (let index = 0; index < tableRow.length; index++) {
      state.heightArray.push('auto')
    }

    state.heightArray = Object.keys(tableRow).map(
      (key: any) => `${tableRow[key].clientHeight}px`
    )
  })
}

export const handleAchievementsSortByAffiliation = (
  data: any,
  checkAffiliationKey: string
) => {
  // 児童発達
  const jihatsuSortData = data.filter(
    (element: any) => element[checkAffiliationKey] === '1'
  )

  // 放デイ
  const houdaySortData = data.filter(
    (element: any) => element[checkAffiliationKey] === '0'
  )

  // 保訪
  const visitSortData = data.filter(
    (element: any) => element[checkAffiliationKey] === '2'
  )

  const concatData = Array.prototype.concat(
    jihatsuSortData,
    houdaySortData,
    visitSortData
  )

  return concatData
}

export const handleGetCheckOfficeNumber = (
  officeUnitflg: number,
  officeNumber: string
) => {
  let checkOfficeNumber = officeNumber

  if (officeUnitflg === 1) {
    checkOfficeNumber = String(checkOfficeNumber).slice(0, -1)
  }

  checkOfficeNumber = ('0000000000' + checkOfficeNumber).slice(-10)

  return checkOfficeNumber
}

export const handleGetAchievementsArrayByOfficeUnitsGroupCldIdByAllAffiliation = (
  achievementsAllArray: any[],
  childBillingGroupArray: any[],
  cldId: string
) => {
  const targetAchievementsArray: any[] = []

  const targetChildBillingGroupArray = childBillingGroupArray.filter(
    (childBillingGroup: ChildOfficeUnitsBillingGroupType) =>
      childBillingGroup.cld_id === cldId
  )

  const targetLinkedCldIdArray = Array.from(
    new Set(
      targetChildBillingGroupArray.map(
        (childBillingGroup: ChildOfficeUnitsBillingGroupType) =>
          childBillingGroup.linked_cld_id
      )
    )
  )

  targetLinkedCldIdArray.forEach((linkedCldId: string) => {
    const targetAchievementsArrayByLinkedCldId = achievementsAllArray.filter(
      (achievements: ResponseAchievementsType) =>
        achievements.cld_id === linkedCldId
    )

    targetAchievementsArray.push(...targetAchievementsArrayByLinkedCldId)
  })

  return targetAchievementsArray
}

export const handleGetAchievementsArrayByOfficeUnitsGroupCldId = (
  achievementsAllArray: any[],
  childBillingGroupArray: any[],
  cldAchievementTargetAffiliation: string,
  cldId: string
) => {
  const targetAchievementsArray: any[] = []

  const targetChildBillingGroupArray = childBillingGroupArray.filter(
    (childBillingGroup: ChildOfficeUnitsBillingGroupType) =>
      childBillingGroup.cld_id === cldId
  )

  const targetLinkedCldIdArray = Array.from(
    new Set(
      targetChildBillingGroupArray.map(
        (childBillingGroup: ChildOfficeUnitsBillingGroupType) =>
          childBillingGroup.linked_cld_id
      )
    )
  )

  targetLinkedCldIdArray.forEach((linkedCldId: string) => {
    const targetAchievementsArrayByLinkedCldId = achievementsAllArray.filter(
      (achievements: ResponseAchievementsType) =>
        achievements.cld_id === linkedCldId &&
        achievements.affiliation === cldAchievementTargetAffiliation
    )

    targetAchievementsArray.push(...targetAchievementsArrayByLinkedCldId)
  })

  return targetAchievementsArray
}

export const handleGetCldAchievementsObj = (
  state: any,
  bulkAchievementsArray: any[],
  childBillingGroupArray: ChildOfficeUnitsBillingGroupType[],
  targetCldInfo: any,
  targetCldId: string,
  targetCldAffiliation: string,
  isBillingListMode = false
) => {
  const cldAchievementsObj: { [key: string]: any } = {}

  cldAchievementsObj['cld_id'] = targetCldId

  cldAchievementsObj.affiliation = targetCldAffiliation

  const targetAchievementsArray = bulkAchievementsArray.filter(
    (achievements: any) =>
      achievements.cld_id === targetCldId &&
      achievements.affiliation === targetCldAffiliation
  )

  const achievementsArrayByOfficeUnitsGroupCldId = handleGetAchievementsArrayByOfficeUnitsGroupCldId(
    bulkAchievementsArray,
    childBillingGroupArray,
    cldAchievementsObj.affiliation,
    cldAchievementsObj['cld_id']
  )

  targetAchievementsArray.push(...achievementsArrayByOfficeUnitsGroupCldId)

  if (isBillingListMode) {
    return {
      targetAchievementsArray: targetAchievementsArray,
    }
  }

  if (targetCldAffiliation === '0' || targetCldAffiliation === '1') {
    cldAchievementsObj.currentDateAchievements = handleDataSet(
      state,
      targetAchievementsArray,
      targetCldInfo
    )
  } else if (targetCldAffiliation === '2') {
    cldAchievementsObj.currentDateAchievements = handleDataSetByVisitAchievements(
      state,
      targetAchievementsArray,
      targetCldInfo
    )
  }

  return cldAchievementsObj
}

export const handleBulkAchievementsArraySet = (
  state: any,
  bulkAchievementsArray: any[],
  bulkVisitAchievementsArray: any[],
  achievementsCldInfoArray: any[],
  childBillingGroupArray: ChildOfficeUnitsBillingGroupType[]
) => {
  let bulkAchievementsArrayByCld: any[] = []

  const bulkAchievementsAndBulkVisitAchievementsArray = bulkAchievementsArray.concat(
    bulkVisitAchievementsArray
  )

  const cldIdArray = Array.from(
    new Set(
      achievementsCldInfoArray.map(
        (achievementsCldInfo: any) => achievementsCldInfo.cld_id
      )
    )
  )

  cldIdArray.forEach((cldId: string) => {
    const achievementsByCldId = bulkAchievementsAndBulkVisitAchievementsArray.filter(
      (bulkAchievementsAndBulkVisitAchievements: any) =>
        bulkAchievementsAndBulkVisitAchievements.cld_id === cldId
    )

    const achievementsArrayByOfficeUnitsGroupCldId = handleGetAchievementsArrayByOfficeUnitsGroupCldIdByAllAffiliation(
      bulkAchievementsAndBulkVisitAchievementsArray,
      childBillingGroupArray,
      cldId
    )

    const allAchievementsByCldId = achievementsByCldId.concat(
      achievementsArrayByOfficeUnitsGroupCldId
    )

    const targetCldInfo = achievementsCldInfoArray.find(
      (cldInfo: { cld_id: string }) => cldInfo.cld_id === cldId
    )

    const targetCldId = targetCldInfo.cld_id

    if (
      allAchievementsByCldId.every(
        (achievements: any) =>
          achievementsByCldId[0].affiliation === achievements.affiliation
      )
    ) {
      if (
        achievementsByCldId[0].affiliation === '0' ||
        achievementsByCldId[0].affiliation === '1'
      ) {
        const cldAchievementsObj = handleGetCldAchievementsObj(
          state,
          bulkAchievementsArray,
          childBillingGroupArray,
          targetCldInfo,
          targetCldId,
          achievementsByCldId[0].affiliation
        )

        bulkAchievementsArrayByCld.push(cldAchievementsObj)
      } else if (achievementsByCldId[0].affiliation === '2') {
        const cldAchievementsObj = handleGetCldAchievementsObj(
          state,
          bulkVisitAchievementsArray,
          childBillingGroupArray,
          targetCldInfo,
          targetCldId,
          achievementsByCldId[0].affiliation
        )

        bulkAchievementsArrayByCld.push(cldAchievementsObj)
      }
    } else {
      const cldAffiliationArray = Array.from(
        new Set(
          allAchievementsByCldId.map(
            (achievements: any) => achievements.affiliation
          )
        )
      )

      cldAffiliationArray.forEach((affiliation: any) => {
        if (affiliation === '0' || affiliation === '1') {
          const cldAchievementsObj = handleGetCldAchievementsObj(
            state,
            bulkAchievementsArray,
            childBillingGroupArray,
            targetCldInfo,
            targetCldId,
            affiliation
          )

          bulkAchievementsArrayByCld.push(cldAchievementsObj)
        } else if (affiliation === '2') {
          const cldAchievementsObj = handleGetCldAchievementsObj(
            state,
            bulkVisitAchievementsArray,
            childBillingGroupArray,
            targetCldInfo,
            targetCldId,
            affiliation
          )

          bulkAchievementsArrayByCld.push(cldAchievementsObj)
        }
      })
    }
  })

  bulkAchievementsArrayByCld = [
    ...handleAchievementsSortByAffiliation(
      bulkAchievementsArrayByCld,
      'affiliation'
    ),
  ]

  return bulkAchievementsArrayByCld
}

export const useSetValue = (state: any, props: any, context: SetupContext) => {
  const handleSetVisitValue = (key: string, value: any) => {
    state.noteParam.dataObject[key] = value

    if (state.noteParam.dataObject.visitKasanFirst !== '1') {
      state.noteParam.dataObject.visitLeader = ''
      state.noteParam.dataObject.visitLeaderName = ''
    }
  }

  const handleSetValue = (key: string, value: any) => {
    state.noteParam.dataObject[key] = value

    // 事業所内相談支援加算が30分以内の場合は適用されないアラートを表示
    if (handleIsConsultationAddition30Minutes(key, state)) {
      alert(
        '事業所内相談支援加算の実施時間が30分未満の場合は加算が適用されません。'
      )
    }

    const checkKeyArray: string[] = [
      'flg',
      'alternativeSupport',
      'comeTimeHour',
      'comeTimeMinute',
      'returnTimeHour',
      'returnTimeMinute',
    ]

    if (checkKeyArray.some((checkKey: string) => checkKey === key)) {
      state.isChanged = true
    }

    context.root.$nextTick(() => {
      if (handleIsCheckPickAndSendReset(state.noteParam.dataObject)) {
        alert('出欠が出席(欠席加算Ⅱでない)以外なので送迎の選択が外れます。')
        state.noteParam.dataObject.pick = 0
        state.noteParam.dataObject.send = 0
      }
    })

    if (
      handleIsConsultationAdditionAndHomeAdditionDuplicate(key, state, 'input')
    ) {
      alert('家庭連携加算と事業所内相談支援加算は同日に算定できません。')

      state.isUpdate = false

      context.root.$nextTick(() => {
        state.isUpdate = true
      })
    }
  }

  const handleSetSelectValue = (setObj: { key: string; value: string }) => {
    handleSetValue(setObj.key,setObj.value)
  }

  const handleDeleteMode = () => {
    if (state.deleteMode) {
      state.deleteMode = false
    } else {
      console.log(state.deleteMode)
      state.deleteMode = true
    }
  }

  const handleTimeErrorSet = (key: string, errorTimeMessage: string) => {
    if (errorTimeMessage) {
      state.errorList[key] = []
      state.errorList[key].push(errorTimeMessage)
    } else {
      delete state.errorList[key]
    }
  }

  return {
    handleSetVisitValue,
    handleSetValue,
    handleDeleteMode,
    handleTimeErrorSet,
    handleSetSelectValue,
  }
}

const handleIsDataTempAtAndAtFlgValue = (checkFlg: any) => {
  if (checkFlg === null || checkFlg === '' || checkFlg === undefined) {
    return false
  } else {
    return true
  }
}

// 利用種類
export const handleIsTemporaryAttendance = (
  targetObj: cldBookForAchievementsType
) => {
  let res = false

  if (
    handleIsDataTempAtAndAtFlgValue(targetObj.flg) &&
    !(
      targetObj.temporaryAttendance === 0 || targetObj.temporaryAttendance === 1
    )
  ) {
    res = true
  }

  return res
}

// 出欠種類
export const handleIsValidAttendance = (
  targetObj: cldBookForAchievementsType
) => {
  let res = false

  if (targetObj.flg !== 1) {
    targetObj.alternativeSupport = '0'
  }

  if (
    handleIsDataTempAtAndAtFlgValue(targetObj.temporaryAttendance) &&
    !(targetObj.flg === 0 || targetObj.flg === 1 || targetObj.flg === 2)
  ) {
    res = true
  }

  return res
}

export const handleIsValidVisitFlg = (
  targetObj: cldBookForAchievementsType
) => {
  let res = false

  if (
    !(
      targetObj.visitFlg === 0 ||
      targetObj.visitFlg === 1 ||
      targetObj.visitFlg === ''
    )
  ) {
    res = true
  }

  return res
}

export const handleUpdateAchievementsValid = (
  state: any,
  props: any,
  isCsvReBilling = false
) => {

  try {
    // CSVによる再請求以外
    if (!isCsvReBilling) {
      if (handleIsTemporaryAttendance(state.noteParam.dataObject)) {
        alert('出欠の利用種類を選択してください。')
        throw new Error('')
      }

      if (handleIsValidAttendance(state.noteParam.dataObject)) {
        alert('出欠の出欠種類を選択してください。')
        throw new Error('')
      }
    }

    if (handleValidIsDeletePattern(state)) {
      if (props.targetDay && !isCsvReBilling) {
        const res = confirm(
          '出欠種類が出席・欠席以外または加算項目がすべてなしのため、実績記録は作成されませんがよろしいですか？'
        )

        if (!res) {
          throw new Error('')
        }
      } else if (props.targetDay && isCsvReBilling) {
        alert(
          '出欠種類が出席・欠席以外または加算項目がすべてなしのため、削除画面に切り替わります。'
        )

        state.deleteMode = true
        throw new Error('')
      } else {
        alert(
          '出欠種類が出席・欠席以外または加算項目がすべてなしのため、実績記録の新規作成をすることができません。'
        )
        throw new Error('')
      }
    }

    if (
      state.noteParam.dataObject.affiliation == '0' &&
      state.noteParam.dataObject.flg == 1 &&
      (state.noteParam.dataObject.provisionForm === '' ||
        state.noteParam.dataObject.provisionForm === undefined ||
        state.noteParam.dataObject.provisionForm === null)
    ) {
      alert('提供形態を選択してください。')
      throw new Error('')
    }

    if (handleIsCheckPickAndSendReset(state.noteParam.dataObject)) {
      alert('送迎は出欠が出席以外の場合は算定することはできません。')
      throw new Error('')
    }

    if (
      !handleIsAbsenceAddition2(state) &&
      state.noteParam.dataObject.flg !== 0
    ) {
      state.noteParam.dataObject.absenceSupport = ''
    }

    if (handlePostIsConsultationAddition30Minutes(state)) {
      alert(
        '事業所内相談支援加算の実施時間が30分未満の場合は加算が適用されないため、実績を新規作成・編集することはできません。'
      )
      throw new Error('')
    }

    if (handleIsPostConsultationAdditionAndHomeAdditionDuplicate(state)) {
      alert('家庭連携加算と事業所内相談支援加算は同日に算定できません。')
      throw new Error('')
    }

    if (Object.keys(state.errorList).length !== 0) {
      Object.keys(state.errorList).some((key: string) => {
        alert(`${state.errorList[key]}をご確認ください。`)
        return true
      })
      throw new Error('')
    }

    if (state.noteParam.dataObject.flg !== 1) {
      state.noteParam.dataObject.alternativeSupport = '0'
      state.noteParam.dataObject.kasanStrength = '0'
      state.noteParam.dataObject.jihatsuKasanStrength = '0'
      state.noteParam.dataObject.kasanExtended = '0'
      state.noteParam.dataObject.jihatsuKasanExtended = '0'
    }

    return true
  } catch (error) {
    return false
  }
}

export const handleUpdateVisitAchievementsValid = (
  state: any,
  props: any,
  isCsvReBilling = false
) => {
  try {
    if (handleIsValidVisitFlg(state.noteParam.dataObject)) {
      alert('実施または実施キャンセルを選択してください。')
      throw new Error('')
    }

    if (handleValidIsDeletePattern(state, true)) {
      if (props.targetDay && !isCsvReBilling) {
        const res = confirm(
          '保育所等訪問支援が実施以外または加算項目がすべてなしのため、実績記録は作成されませんがよろしいですか？'
        )

        if (!res) {
          throw new Error('')
        }
      } else if (props.targetDay && isCsvReBilling) {
        alert(
          '保育所等訪問支援が実施以外または加算項目がすべてなしのため、削除画面に切り替わります。'
        )

        state.deleteMode = true
        throw new Error('')
      } else {
        alert(
          '保育所等訪問支援が実施以外または加算項目がすべてなしのため、実績記録の新規作成をすることができません。'
        )
        throw new Error('')
      }
    }

    if (Object.keys(state.errorList).length !== 0) {
      Object.keys(state.errorList).some((key: string) => {
        alert(`${state.errorList[key]}をご確認ください。`)
        return true
      })
      throw new Error('')
    }

    if (state.noteParam.dataObject.visitFlg === '') {
      // state.noteParam.dataObject.visitKasanFirst = '0'
      state.noteParam.dataObject.isVisitMultiple = '0'
      state.noteParam.dataObject.visitComeTimeHour = '00'
      state.noteParam.dataObject.visitComeTimeMinute = '00'
      state.noteParam.dataObject.visitReturnTimeHour = '00'
      state.noteParam.dataObject.visitReturnTimeMinute = '00'
      state.noteParam.dataObject.visitKasanSpecialArea = '0'
      state.noteParam.dataObject.visitKasanWelfare = '0'
      state.noteParam.dataObject.visitManager = ''
      state.noteParam.dataObject.visitManagerName = ''
      // state.noteParam.dataObject.visitLeader = ''
      // state.noteParam.dataObject.visitLeaderName = ''
    }

    return true
  } catch (error) {
    return false
  }
}

export const useComputed = (state: any, props: any) => {
  const staffName = computed(() => {
    if (props.currentStaff) {
      return props.currentStaff.last_name + props.currentStaff.first_name
    } else {
      return ''
    }
  })

  const dayOptionArray = computed(() => {
    const dayOptionArray: number[] = []

    for (let index = 1; index <= state.lastDayOfMonth; index++) {
      dayOptionArray.push(index)
    }
    return dayOptionArray
  })

  const isAbsenceAddition2 = computed(() => {
    let res = false

    if (handleIsAbsenceAddition2(state)) {
      res = true
      if (state.isChanged) {
        alert(
          '利用した時間が30分以内のため欠席加算IIが適用されます。\n適用させたくない場合は代替的な支援を「あり」にしてください。'
        )
      }
    }

    return res
  })

  const isNonDelete = computed(() => {
    let res = true

    if (state.deleteKeyword === '削除') {
      res = false
    }

    return res
  })

  return {
    dayOptionArray,
    staffName,
    isAbsenceAddition2,
    isNonDelete,
  }
}

export const useCommonAchievements = <
  T extends {
    currentDateAchievements: {
      [key: string]: any
    }
    modal: boolean
    visitModal: boolean
    defaultEmptyAchievementsArray: {
      [key: string]: any
    }
    targetDay: number | null
  }
>(
  state: T
) => {
  const handlePrint = (activeAffiliation: string) => {
    const prevHtmlTitle = document.title

    const taregetPrintTitleObj = defineObject.SERVICE_CODE_TYPE_AND_AFFILIATION_ARRAY.find(
      (tabType: ServiceCodeTypeAndAffiliationType) =>
        tabType.affiliation === activeAffiliation
    )

    let targetPrintTitle = ''

    if (taregetPrintTitleObj) {
      targetPrintTitle = `${taregetPrintTitleObj.serviceName}提供実績記録表`
    }

    const titleArray = [
      targetPrintTitle,

      // 事業所名
      state.currentDateAchievements.officeName,
      // 児童名
      `${state.currentDateAchievements.name} さん`,
    ]
    const titleString = titleArray.join(' | ')
    document.title = titleString

    window.print()

    document.title = prevHtmlTitle
  }

  const handleSetActiveClass = (
    targetDisplayAchievementsArray: any,
    index?: number,
    value?: boolean
  ) => {
    if (value && index !== undefined) {
      targetDisplayAchievementsArray[index].activeClass = value

      targetDisplayAchievementsArray.splice(
        index,
        1,
        targetDisplayAchievementsArray[index]
      )
    } else {
      const achievementsArray = [
        ...targetDisplayAchievementsArray.map((achievements: any) => {
          achievements.activeClass = false
          return achievements
        }),
      ]

      targetDisplayAchievementsArray.splice(
        0,
        targetDisplayAchievementsArray.length
      )

      targetDisplayAchievementsArray.push(...achievementsArray)
    }
  }

  const handleCloseModal = () => {
    state.modal = false
    state.visitModal = false

    if (
      state.currentDateAchievements.displayAchievementsArray &&
      state.currentDateAchievements.displayAchievementsArray.length !== 0
    ) {
      handleSetActiveClass(
        state.currentDateAchievements.displayAchievementsArray
      )
    } else {
      handleSetActiveClass(state.defaultEmptyAchievementsArray)
    }
  }

  const handleOpenModal = (targetDay: number, index: number) => {
    if (
      state.currentDateAchievements.displayAchievementsArray &&
      state.currentDateAchievements.displayAchievementsArray.length !== 0
    ) {
      handleSetActiveClass(
        state.currentDateAchievements.displayAchievementsArray,
        index,
        true
      )
    } else {
      handleSetActiveClass(state.defaultEmptyAchievementsArray, index, true)
    }

    state.modal = true
    if (targetDay) {
      state.targetDay = targetDay
    } else {
      state.targetDay = 0
    }
  }

  const handleOpenVisitModal = (targetDay: number, index: number) => {
    if (
      state.currentDateAchievements.displayAchievementsArray &&
      state.currentDateAchievements.displayAchievementsArray.length !== 0
    ) {
      handleSetActiveClass(
        state.currentDateAchievements.displayAchievementsArray,
        index,
        true
      )
    } else {
      handleSetActiveClass(state.defaultEmptyAchievementsArray, index, true)
    }

    state.visitModal = true

    if (targetDay) {
      state.targetDay = targetDay
    } else {
      state.targetDay = 0
    }
  }

  return {
    handlePrint,
    handleSetActiveClass,
    handleCloseModal,
    handleOpenModal,
    handleOpenVisitModal,
  }
}

export const getAffiliationBadge = (status: string) => {
  switch (status) {
    case '1':
      return 'warning'
    case '0':
      return 'info'
    case '2':
      return 'pink'
    default:
      return ''
  }
}

export const getAffiliationBadgeIconText = (status: string) => {
  const targetAffiliation = defineObject.AFFILIATION_ICON_ARRAY.find(
    (affiliationObj: { [key: string]: string }) =>
      affiliationObj.value === status
  )

  return targetAffiliation ? targetAffiliation.text : ''
}

export const getTemporaryAttendanceText = (tempAtFlg: number) => {
  const targetTempAtObj = defineObject.TEMPORARY_ATTENDANCE_MODAL_ARRAY.find(
    (tempAtObj: { [key: string]: string | number }) =>
      tempAtObj.value === tempAtFlg
  )

  return targetTempAtObj ? targetTempAtObj.label : ''
}

export const getAttendanceText = (atFlg: number) => {
  return defineObject.ATTENDANCE_ARRAY[atFlg]
    ? defineObject.ATTENDANCE_ARRAY[atFlg]
    : ''
}

export const getCalculationTimeText = (targetValue: string) => {
  const obj = defineObject.CALCULATION_TIME_INPUT_ARRAY.find(
    (obj: { [key: string]: string | number }) =>
    obj.value === targetValue
  )
  return obj ? obj.label : ''
}

export const getProvisionFormText = (provisionFormFlg: string) => {
  const targetProvisionFormObj = defineObject.PROVISION_FORM_ARRAY.find(
    (provisionFormObj: { [key: string]: string | number }) =>
      provisionFormObj.value === provisionFormFlg
  )

  return targetProvisionFormObj ? targetProvisionFormObj.label : ''
}

export const getPickAndSendText = (pick: number, send: number) => {
  if (!pick && !send) {
    return ''
  } else if (pick && send) {
    return '往路・復路'
  } else if (pick && !send) {
    return '往路'
  } else if (!pick && send) {
    return '復路'
  }
}

// 家庭連携加算/医療体制連携加算 number
// 関係機関連携加算/事業所内相談支援加算 string 複数選択可能

export const getAdditionView = (
  additionValue: string | number,
  additionKey: string,
  multipleFlg = false
) => {
  let obj: { [key: string]: string | number } | undefined = undefined

  if (
    (additionKey === 'home_addition' ||
      additionKey === 'medical_cooperation') &&
    String(additionValue) !== '0'
  ) {
    obj = defineObject.STR_AVAILABLE_ARRAY.find(
      (obj: { [key: string]: string }) => obj.value === String(additionValue)
    )
  } else if (
    (additionKey === 'organization_addition' ||
      additionKey === 'consultation_addition') &&
    additionValue !== 0 &&
    !multipleFlg
  ) {
    obj = defineObject.MULTIPLE_ADDITION_CHECK_ARRAY.find(
      (obj: { [key: string]: string | number }) =>
        obj.additionKey === '1' && obj.value === additionValue
    )
  } else if (
    (additionKey === 'organization_addition' ||
      additionKey === 'consultation_addition') &&
    additionValue !== 0 &&
    multipleFlg
  ) {
    obj = defineObject.MULTIPLE_ADDITION_CHECK_ARRAY.find(
      (obj: { [key: string]: string | number }) =>
        obj.additionKey === '2' && obj.value === additionValue
    )
  }

  if (obj) return obj.label
}

// 令和6年度版 加算項目ラベル取得
// 家庭連携加算/医療体制連携加算 number
// 関係機関連携加算 string 複数選択可能
export const getRevision2024AdditionView = (
  additionValue: string | number, // 加算項目値
  additionKey: string, // 加算項目名
  multipleFlg = false, // 複数選択可能フラグ（関係機関連携加算のみ）
  additionNumberKey = '0' // 加算項目連番（関係機関連携加算のみ）
) => {
  let obj: { [key: string]: string | number } | undefined = undefined

  if (
    (
      additionKey === 'home_addition' ||
      additionKey === 'medical_cooperation' ||
      additionKey === 'kasan_shuchu' ||
      additionKey === 'kasan_senmonteki_jisshi' ||
      additionKey === 'kasan_tsusho_jiritsu' ||
      additionKey === 'kasan_nyuyoku' ||
      additionKey === 'kasan_kosodate_support' ||
      additionKey === 'kasan_jiritsu_support' ||
      additionKey === 'kasan_kino_shogaiji' ||
      additionKey === 'kasan_meal_offer'
    ) &&
    String(additionValue) !== '0'
  ) {
    obj = defineObject.STR_AVAILABLE_ARRAY.find(
      (obj: { [key: string]: string }) => obj.value === String(additionValue)
    )
  } else if (
    (
      additionKey === 'organization_addition'
    ) &&
    additionValue !== 0 &&
    !multipleFlg
  ) {
    obj = defineObject.MULTIPLE_ADDITION_CHECK_REVISION_2024_ARRAY.find(
      (obj: { [key: string]: string | number }) =>
        obj.additionKey === '1' && obj.value === additionValue
    )
  } else if (
    (
      additionKey === 'organization_addition'
    ) &&
    additionValue !== 0 &&
    multipleFlg
  ) {
    obj = defineObject.MULTIPLE_ADDITION_CHECK_REVISION_2024_ARRAY.find(
      (obj: { [key: string]: string | number }) =>
      additionNumberKey === obj.additionKey &&
      obj.value === additionValue
    )
  } else if (
    additionKey === 'kasan_jigyoshokan' ||
    additionKey === 'kasan_kazoku_shien'
  ) {
    obj = defineObject.ONE_ADDITION_MULTIPLE_CHECK_ARRAY.find(
      (obj: { [key: string]: string | number }) =>
        obj.value === additionValue
    )
  }
  if (obj) return obj.label
}

export const handleIsValidConsultationAddition30Minutes = (
  setKey: string,
  targetObj: any
) => {
  let res = false
  let consultationAdditionKey = ''

  const RegExp = /StartHour|StartMinute|EndHour|EndMinute/g

  if (!RegExp.test(setKey)) return

  consultationAdditionKey = setKey.replace(
    /StartHour|StartMinute|EndHour|EndMinute/g,
    ''
  )

  if (
    defineObject.CONSULTATION_ADDITION_KEY_ARRAY.some(
      (key: string) => key === consultationAdditionKey
    ) &&
    Number(targetObj[consultationAdditionKey]) === 1
  ) {
    const diff = calculationOfUsageTime(
      targetObj[`${consultationAdditionKey}StartHour`],
      targetObj[`${consultationAdditionKey}StartMinute`],
      targetObj[`${consultationAdditionKey}EndHour`],
      targetObj[`${consultationAdditionKey}EndMinute`]
    )

    if (diff > 0 && diff < 30) {
      res = true
    }
  }

  return res
}

export const handleIsValidAbsenceAddition2 = (
  targetObj: cldBookForAchievementsType
) => {
  let res = false

  const diff = calculationOfUsageTime(
    targetObj.comeTimeHour,
    targetObj.comeTimeMinute,
    targetObj.returnTimeHour,
    targetObj.returnTimeMinute
  )

  if (
    diff > 0 &&
    diff <= 30 &&
    targetObj.flg === 1 &&
    targetObj.affiliation === '0' &&
    targetObj.alternativeSupport === '0'
  ) {
    res = true
  }

  return res
}

// 提供形態
export const handleIsValidProvisionForm = (
  targetObj: cldBookForAchievementsType
) => {
  let res = false

  // 型修正
  targetObj.provisionForm = String(targetObj.provisionForm)

  if (
    targetObj.affiliation == '0' &&
    targetObj.flg == 1 &&
    (targetObj.provisionForm === '' ||
      targetObj.provisionForm === undefined ||
      targetObj.provisionForm === null)
  ) {
    res = true
  }

  return res
}

// 送迎と出席チェック
export const handleIsValidPickAndSend = (
  targetObj: cldBookForAchievementsType
) => {
  let res = false

  // 型修正
  targetObj.pick = Number(targetObj.pick)
  targetObj.send = Number(targetObj.send)

  if (targetObj.flg !== 1 && (targetObj.pick || targetObj.send)) {
    res = true
  }

  return res
}

// 削除パターン加算
const handleIsValidDeletePatternAddition = (targetObj: any) => {
  let isDeletePattern = false

  let prefix = ''

  if (targetObj.affiliation === JIHATSU) {
    prefix = 'jihatsu'
  }

  let notCnt = 0

  defineObject.ACHIEVEMENTS_ADDITION_KEY_ARRAY.forEach(
    (keyObj: { [key: string]: string }) => {
      let additionKey = keyObj.key

      if (prefix) {
        additionKey =
          prefix + additionKey.charAt(0).toUpperCase() + additionKey.slice(1)
      }

      if (Number(targetObj[additionKey])) {
        notCnt++
      }
    }
  )

  if (notCnt === 0) {
    isDeletePattern = true
  }

  return isDeletePattern
}

// 削除パターン出席
const handleIsValidDeletePatternFlg = (
  targetObj: cldBookForAchievementsType
) => {
  let isDeletePattern = false

  if (targetObj.flg !== 0 && targetObj.flg !== 1) {
    isDeletePattern = true
  }

  return isDeletePattern
}

// 削除パターン
export const handleIsValidDeletePattern = (
  targetObj: cldBookForAchievementsType
) => {
  let isDeletePattern = false

  if (
    handleIsValidDeletePatternAddition(targetObj) &&
    handleIsValidDeletePatternFlg(targetObj)
  ) {
    isDeletePattern = true
  }
  return isDeletePattern
}

// 事業所内相談支援加算と家庭連携加算
export const handleIsValidConsultationAdditionAndHomeAdditionDuplicate = (
  targetObj: {
    [key: string]: any
  },
  setObj: {
    key: cldBookForAchievementsTypeKey
    value: cldBookForAchievementsTypeValue
  } | null = null
) => {
  let res = false

  if ((setObj && Number(setObj.value) === 1) || !setObj) {
    let prefix = ''

    if (targetObj.affiliation === JIHATSU) {
      prefix = 'jihatsu'
    }

    let homeAdditionCnt = false
    let consultationAdditionCnt = false

    const achievementsAdditionKeyArray = defineObject.ACHIEVEMENTS_ADDITION_KEY_ARRAY.filter(
      (keyObj: { [key: string]: string }) =>
        keyObj.key === 'homeAddition' ||
        keyObj.key === 'consultationAddition' ||
        keyObj.key === 'consultationAddition2'
    )

    achievementsAdditionKeyArray.forEach(
      (keyObj: { [key: string]: string }) => {
        let additionKey = keyObj.key

        if (prefix) {
          additionKey =
            prefix + additionKey.charAt(0).toUpperCase() + additionKey.slice(1)
        }

        if (Number(targetObj[additionKey]) && keyObj.key === 'homeAddition') {
          homeAdditionCnt = true
        }

        if (
          Number(targetObj[additionKey]) &&
          (keyObj.key === 'consultationAddition' ||
            keyObj.key === 'consultationAddition2')
        ) {
          consultationAdditionCnt = true
        }
      }
    )

    if (!setObj && consultationAdditionCnt && homeAdditionCnt) {
      res = true
    } else if (setObj) {
      switch (setObj.key) {
        case 'homeAddition':
        case 'jihatsuHomeAddition':
          if (consultationAdditionCnt) res = true
          break

        case 'consultationAddition':
        case 'consultationAddition2':
        case 'jihatsuConsultationAddition':
        case 'jihatsuConsultationAddition2':
          if (homeAdditionCnt) res = true
          break
      }
    }
  }

  return res
}

// 事業所内相談支援加算の30分以内のチェック
export const handleIsValidAllConsultationAddition30Minutes = (
  targetObj: any
) => {
  let res = false

  let prefix = ''

  if (targetObj.affiliation === JIHATSU) {
    prefix = 'jihatsu'
  }

  let errCnt = 0

  const achievementsAdditionKeyArray = defineObject.ACHIEVEMENTS_ADDITION_KEY_ARRAY.filter(
    (keyObj: { [key: string]: string }) =>
      keyObj.key === 'consultationAddition' ||
      keyObj.key === 'consultationAddition2'
  )

  achievementsAdditionKeyArray.forEach((keyObj: { [key: string]: string }) => {
    let additionKey = keyObj.key

    if (prefix) {
      additionKey =
        prefix + additionKey.charAt(0).toUpperCase() + additionKey.slice(1)
    }

    if (
      Number(targetObj[additionKey]) &&
      handleIsValidConsultationAddition30Minutes(
        `${additionKey}StartHour`,
        targetObj
      )
    ) {
      errCnt++
    }
  })

  if (errCnt > 0) {
    res = true
  }

  return res
}

// 備考全角チェック
export const handleIsValidRemarks = (targetObj: cldBookForAchievementsType) => {
  let res = false

  if (targetObj.remarks && !validFullSize(String(targetObj.remarks))) {
    res = true
  }

  return res
}

// 欠席時の支援内容全角チェック
export const handleIsValidAbsenceSupport = (
  targetObj: cldBookForAchievementsType
) => {
  let res = false

  if (!handleIsValidAbsenceAddition2(targetObj) && targetObj.flg !== 0) {
    targetObj.absenceSupport = ''
  }

  if (targetObj.absenceSupport && !validFullSize(targetObj.absenceSupport)) {
    res = true
  }

  return res
}

// 開始と終了チェック
export const handleIsValidServiceTime = (
  targetObj: cldBookForAchievementsType
) => {
  let res = false

  if (
    targetObj.flg === 1 &&
    calculationOfUsageTime(
      targetObj.comeTimeHour,
      targetObj.comeTimeMinute,
      targetObj.returnTimeHour,
      targetObj.returnTimeMinute
    ) <= 0
  ) {
    res = true
  }

  return res
}

// 各加算の時間チェック
export const handleIsValidAdditionTime = (
  targetObj: any,
  additionKey: string
) => {
  let res = false

  let prefix = ''

  if (targetObj.affiliation === JIHATSU) {
    prefix = 'jihatsu'
  }

  const achievementsAdditionKeyArray = defineObject.ACHIEVEMENTS_ADDITION_KEY_ARRAY.filter(
    (keyObj: { [key: string]: string }) => keyObj.key === additionKey
  )

  achievementsAdditionKeyArray.some((keyObj: { [key: string]: string }) => {
    let additionKey = keyObj.key

    if (prefix) {
      additionKey =
        prefix + additionKey.charAt(0).toUpperCase() + additionKey.slice(1)
    }

    // 型修正
    switch (keyObj.key) {
      case 'homeAddition':
      case 'medicalCooperation':
        targetObj[additionKey] = String(targetObj[additionKey])
        break

      case 'organizationAddition':
      case 'consultationAddition':
        targetObj[additionKey] = Number(targetObj[additionKey])
        break

      case 'organizationAddition2':
      case 'consultationAddition2':
        targetObj[additionKey] = Number(targetObj[additionKey])
        break
    }

    if (
      Number(targetObj[additionKey]) &&
      calculationOfUsageTime(
        targetObj[`${additionKey}StartHour`],
        targetObj[`${additionKey}StartMinute`],
        targetObj[`${additionKey}EndHour`],
        targetObj[`${additionKey}EndMinute`]
      ) <= 0
    ) {
      res = true
      return true
    }
  })

  return res
}

export const handleUpdateBeforeValidAlert = (
  targetObj: cldBookForAchievementsType,
  setObj: {
    key: cldBookForAchievementsTypeKey
    value: cldBookForAchievementsTypeValue
  },
  isMasterRow = false
) => {
  try {
    switch (setObj.key) {
      case 'affiliation': {
        const res = confirm(
          `所属を変更すると${
            isMasterRow ? '行の' : '連絡帳の活動内容と'
          }実績記録の加算項目が初期化されます。よろしいですか？`
        )

        if (!res) throw new Error('キャンセル')
        break
      }

      case 'homeAddition':
      case 'jihatsuHomeAddition':
      case 'consultationAddition':
      case 'consultationAddition2':
      case 'jihatsuConsultationAddition':
      case 'jihatsuConsultationAddition2':
        if (
          handleIsValidConsultationAdditionAndHomeAdditionDuplicate(
            targetObj,
            setObj
          )
        ) {
          alert('家庭連携加算と事業所内相談支援加算は同日に算定できません。')
          throw new Error('キャンセル')
        }
        break
    }

    return true
  } catch (error) {
    if (error instanceof Error) {
      console.error(error.message) //errorがErrorクラスである場合messageがフィールドに含まれることが保証されるので型安全
    } else if (typeof error === 'string') {
      console.log(error)
    } else {
      console.log('unexpected error')
    }
    return false
  }
}

export const handleResetAdditionTime = (targetObj: any) => {
  let prefix = ''

  if (targetObj.affiliation === JIHATSU) {
    prefix = 'jihatsu'
  }

  defineObject.ACHIEVEMENTS_ADDITION_KEY_ARRAY.forEach(
    (keyObj: { [key: string]: string }) => {
      let additionKey = keyObj.key

      if (prefix) {
        additionKey =
          prefix + additionKey.charAt(0).toUpperCase() + additionKey.slice(1)
      }

      if (Number(targetObj[additionKey]) === 0) {
        targetObj[`${additionKey}StartHour`] = '00'
        targetObj[`${additionKey}StartMinute`] = '00'
        targetObj[`${additionKey}EndHour`] = '00'
        targetObj[`${additionKey}EndMinute`] = '00'
      }
    }
  )
}

export const handleUpdateAfterAlert = (
  targetObj: cldBookForAchievementsType,
  setObj: {
    key: cldBookForAchievementsTypeKey
    value: cldBookForAchievementsTypeValue
  }
) => {
  switch (setObj.key) {
    case 'flg':
    case 'temporaryAttendance':
    case 'provisionForm':
    case 'affiliation':
    case 'comeTimeHour':
    case 'comeTimeMinute':
    case 'returnTimeHour':
    case 'returnTimeMinute':
    case 'alternativeSupport':
      if (handleIsValidAbsenceAddition2(targetObj)) {
        alert(
          '利用した時間が30分以内のため欠席加算IIが適用されます。\n適用させたくない場合は代替的な支援を「あり」にしてください。'
        )
      }
      break

    case 'jihatsuConsultationAdditionStartHour':
    case 'jihatsuConsultationAdditionStartMinute':
    case 'jihatsuConsultationAdditionEndHour':
    case 'jihatsuConsultationAdditionEndMinute':
    case 'jihatsuConsultationAddition2StartHour':
    case 'jihatsuConsultationAddition2StartMinute':
    case 'jihatsuConsultationAddition2EndHour':
    case 'jihatsuConsultationAddition2EndMinute':
    case 'consultationAdditionStartHour':
    case 'consultationAdditionStartMinute':
    case 'consultationAddition2StartHour':
    case 'consultationAddition2StartMinute':
    case 'consultationAdditionEndHour':
    case 'consultationAdditionEndMinute':
    case 'consultationAddition2EndHour':
    case 'consultationAddition2EndMinute':
      if (handleIsValidConsultationAddition30Minutes(setObj.key, targetObj)) {
        alert(
          '事業所内相談支援加算の実施時間が30分未満の場合は加算が適用されません。'
        )
      }
      break
  }
}

export const handleUpdateValue = (
  targetObj: cldBookForAchievementsType,
  setObj: {
    key: cldBookForAchievementsTypeKey
    value: cldBookForAchievementsTypeValue
  },
  isMasterRow = false
) => {
  if (!handleUpdateBeforeValidAlert(targetObj, setObj, isMasterRow)) return

  switch (setObj.key) {
    case 'flg':
      if (
        setObj.value !== undefined &&
        setObj.value !== null &&
        setObj.value !== ''
      ) {
        targetObj[setObj.key] = Number(setObj.value)
      } else if (setObj.value === '') {
        targetObj[setObj.key] = ''
      }

      if (handleIsCheckPickAndSendReset(targetObj)) {
        alert('出欠が出席(欠席加算Ⅱでない)以外なので送迎の選択が外れます。')
        targetObj.pick = 0
        targetObj.send = 0
      }
      break

    case 'temporaryAttendance':
    case 'provisionForm':
      if (
        setObj.value !== undefined &&
        setObj.value !== null &&
        setObj.value !== ''
      ) {
        targetObj[setObj.key] = Number(setObj.value)
      } else if (setObj.value === '') {
        targetObj[setObj.key] = ''
      }
      break

    case 'pick':
    case 'send':
    case 'organizationAddition':
    case 'organizationAddition2':
    case 'consultationAddition':
    case 'consultationAddition2':
    case 'jihatsuOrganizationAddition':
    case 'jihatsuOrganizationAddition2':
    case 'jihatsuConsultationAddition':
    case 'jihatsuConsultationAddition2':
      if (setObj.value !== undefined && setObj.value !== null) {
        targetObj[setObj.key] = Number(setObj.value)
      }
      break

    case 'affiliation':
    case 'comeTimeHour':
    case 'comeTimeMinute':
    case 'returnTimeHour':
    case 'returnTimeMinute':
    case 'jihatsuConsultationAdditionStartHour':
    case 'jihatsuConsultationAdditionStartMinute':
    case 'jihatsuConsultationAdditionEndHour':
    case 'jihatsuConsultationAdditionEndMinute':
    case 'jihatsuConsultationAddition2StartHour':
    case 'jihatsuConsultationAddition2StartMinute':
    case 'jihatsuConsultationAddition2EndHour':
    case 'jihatsuConsultationAddition2EndMinute':
    case 'consultationAdditionStartHour':
    case 'consultationAdditionStartMinute':
    case 'consultationAddition2StartHour':
    case 'consultationAddition2StartMinute':
    case 'consultationAdditionEndHour':
    case 'consultationAdditionEndMinute':
    case 'consultationAddition2EndHour':
    case 'consultationAddition2EndMinute':
    case 'homeAddition':
    case 'homeAdditionStartHour':
    case 'homeAdditionStartMinute':
    case 'homeAdditionEndHour':
    case 'homeAdditionEndMinute':
    case 'medicalCooperation':
    case 'medicalCooperationStartHour':
    case 'medicalCooperationStartMinute':
    case 'medicalCooperationEndHour':
    case 'medicalCooperationEndMinute':
    case 'organizationAdditionStartHour':
    case 'organizationAdditionStartMinute':
    case 'organizationAdditionEndHour':
    case 'organizationAdditionEndMinute':
    case 'organizationAddition2StartHour':
    case 'organizationAddition2StartMinute':
    case 'organizationAddition2EndHour':
    case 'organizationAddition2EndMinute':
    case 'kasanExtended':
    case 'kasanStrength':
    case 'jihatsuHomeAddition':
    case 'jihatsuHomeAdditionStartHour':
    case 'jihatsuHomeAdditionStartMinute':
    case 'jihatsuHomeAdditionEndHour':
    case 'jihatsuHomeAdditionEndMinute':
    case 'jihatsuMedicalCooperation':
    case 'jihatsuMedicalCooperationStartHour':
    case 'jihatsuMedicalCooperationStartMinute':
    case 'jihatsuMedicalCooperationEndHour':
    case 'jihatsuMedicalCooperationEndMinute':
    case 'jihatsuOrganizationAdditionStartHour':
    case 'jihatsuOrganizationAdditionStartMinute':
    case 'jihatsuOrganizationAdditionEndHour':
    case 'jihatsuOrganizationAdditionEndMinute':
    case 'jihatsuOrganizationAddition2StartHour':
    case 'jihatsuOrganizationAddition2StartMinute':
    case 'jihatsuOrganizationAddition2EndHour':
    case 'jihatsuOrganizationAddition2EndMinute':
    case 'remarks':
    case 'absenceSupport':
    case 'alternativeSupport':
    case 'jihatsuKasanExtended':
    case 'jihatsuKasanStrength':
      targetObj[setObj.key] = String(setObj.value)
      break
  }

  handleUpdateAfterAlert(targetObj, setObj)

  handleOtherCurrentAffiliationAdditionReset(targetObj)

  handleResetAdditionTime(targetObj)
}

export const handleValidUpdateAchievementsByBulkAchievements = (
  targetObj: cldBookForAchievementsType,
  checkKey = ''
) => {
  try {
    console.log(checkKey)
    if (
      (!checkKey || checkKey === 'temporaryAttendanceAndFlg') &&
      handleIsTemporaryAttendance(targetObj)
    ) {
      alert('出欠の利用種類を選択してください。')
      throw new Error('バリデーション')
    }

    if (
      (!checkKey || checkKey === 'temporaryAttendanceAndFlg') &&
      handleIsValidAttendance(targetObj)
    ) {
      alert('出欠の出欠種類を選択してください。')
      throw new Error('バリデーション')
    }

    if (
      (!checkKey || checkKey === 'temporaryAttendanceAndFlg') &&
      handleIsValidPickAndSend(targetObj)
    ) {
      alert('送迎は出欠が出席以外の場合は算定することはできません。')
      throw new Error('バリデーション')
    }

    if (
      (!checkKey || checkKey === 'provisionForm') &&
      handleIsValidProvisionForm(targetObj)
    ) {
      alert('提供形態を選択してください。')
      throw new Error('バリデーション')
    }

    if (
      (!checkKey || checkKey === 'consultationAddition') &&
      handleIsValidAllConsultationAddition30Minutes(targetObj)
    ) {
      alert(
        '事業所内相談支援加算の実施時間が30分未満の場合は加算が適用されないため、実績を新規作成・編集することはできません。'
      )
      throw new Error('バリデーション')
    }

    if (
      (!checkKey ||
        checkKey === 'homeAddition' ||
        checkKey === 'consultationAddition') &&
      handleIsValidConsultationAdditionAndHomeAdditionDuplicate(targetObj)
    ) {
      alert('家庭連携加算と事業所内相談支援加算は同日に算定できません。')
      throw new Error('バリデーション')
    }

    if (
      (!checkKey || checkKey === 'remarks') &&
      handleIsValidRemarks(targetObj)
    ) {
      alert('備考は全角のみ入力可能です。')
      throw new Error('バリデーション')
    }

    if (
      (!checkKey || checkKey === 'absenceSupport') &&
      handleIsValidAbsenceSupport(targetObj)
    ) {
      alert('欠席時の支援内容は全角のみ入力可能です。')
      throw new Error('バリデーション')
    }

    if (
      (!checkKey || checkKey === 'comeTimeAndReturnTime') &&
      handleIsValidServiceTime(targetObj)
    ) {
      alert('開始と終了の時間をご確認ください。')
      throw new Error('バリデーション')
    }

    if (
      !checkKey ||
      checkKey === 'homeAddition' ||
      checkKey === 'organizationAddition' ||
      checkKey === 'medicalCooperation' ||
      checkKey === 'consultationAddition'
    ) {
      let additionKeyArray = defineObject.ACHIEVEMENTS_ADDITION_KEY_ARRAY

      if (checkKey) {
        additionKeyArray = additionKeyArray.filter(
          (keyObj: { [key: string]: string }) => keyObj.key.includes(checkKey)
        )
      }

      if (
        additionKeyArray.some((keyObj: { [key: string]: string }) =>
          handleIsValidAdditionTime(targetObj, keyObj.key)
        )
      ) {
        const errObj = additionKeyArray.find(
          (keyObj: { [key: string]: string }) =>
            handleIsValidAdditionTime(targetObj, keyObj.key)
        )

        if (errObj) {
          alert(`${errObj.label}の時間をご確認ください。`)
          throw new Error('バリデーション')
        }
      }
    }

    if (!checkKey && handleIsValidDeletePattern(targetObj)) {
      alert(
        'コピーされる値が入力されておりません。出欠もしくは各加算が正しく入力されているか確認してください。'
      )
      throw new Error('バリデーション')
    }

    if (!checkKey) {
      handleOtherCurrentAffiliationAdditionReset(targetObj)
    }

    return false
  } catch (error) {
    if (error instanceof Error) {
      console.error(error.message) //errorがErrorクラスである場合messageがフィールドに含まれることが保証されるので型安全
    } else if (typeof error === 'string') {
      console.log(error)
    } else {
      console.log('unexpected error')
    }
    return true
  }
}

export const handleGetBeneficiaryIdDupErrMsgArray = (
  achivementsArray: ResponseAchievementsType[]
) => {
  const achievementsDupMsgArray: string[] = []

  let achivementsOfCldInfoStringArray = achivementsArray.map(
    (achivements: ResponseAchievementsType) => {
      return `${achivements.year}-${achivements.month}-${achivements.affiliation}-${achivements.child_last_name}-${achivements.child_first_name}`
    }
  )

  achivementsOfCldInfoStringArray = achivementsOfCldInfoStringArray.filter(
    function(x: any, i: number, self: any) {
      return self.indexOf(x) === i
    }
  )

  achivementsOfCldInfoStringArray.forEach(
    (achivementsOfCldInfoString: string) => {
      const year = achivementsOfCldInfoString.split('-')[0],
        month = achivementsOfCldInfoString.split('-')[1],
        affiliation = achivementsOfCldInfoString.split('-')[2],
        childLastName = achivementsOfCldInfoString.split('-')[3],
        childFirstName = achivementsOfCldInfoString.split('-')[4]

      const affiliationText = defineObject.AFFILIATION_ICON_ARRAY.find(
        (afObj: { [key: string]: string }) => afObj.value === affiliation
      )

      achievementsDupMsgArray.push(
        `${year}年${month}月 [${
          affiliationText ? affiliationText.text : ''
        }]${childLastName}${childFirstName}`
      )
    }
  )

  return achievementsDupMsgArray
}

export const handleUpdateAchievementsCldData = (
  achievementsChildData: any,
  setCldInfo: any
) => {
  if (setCldInfo.type === 'ACHIEVEMENTS_CHILD') {
    const achievementsCldSetKeyArray = [
      'child_first_name',
      'child_last_name',
      'child_last_kana',
      'child_first_kana',
      'parents_last_name',
      'parents_first_name',
      'parents_last_kana_1',
      'parents_first_kana_1',
      'beneficiary_id',
      'contract_amount',
      'visit_contract_amount',
    ]

    // 再請求の事業所情報
    achievementsCldSetKeyArray.forEach((achievementsCldSetKey: string) => {
      achievementsChildData[achievementsCldSetKey] =
        setCldInfo[achievementsCldSetKey]
    })
  } else {
    const achievementsCldSetKeyArray = [
      'first_name',
      'last_name',
      'last_kana',
      'first_kana',
      'parents_last_name_1',
      'parents_first_name_1',
      'parents_last_kana_1',
      'parents_first_kana_1',
      'beneficiary_id',
      'contract_amount',
      'visit_contract_amount',
    ]

    achievementsCldSetKeyArray.forEach((achievementsCldSetKey: string) => {
      switch (achievementsCldSetKey) {
        case 'first_name':
        case 'last_name':
        case 'last_kana':
        case 'first_kana':
          achievementsChildData[`child_${achievementsCldSetKey}`] =
            setCldInfo[achievementsCldSetKey]
          break

        case 'parents_last_name_1':
        case 'parents_first_name_1':
          achievementsChildData[achievementsCldSetKey.slice(0, -2)] =
            setCldInfo[achievementsCldSetKey]
          break

        default:
          achievementsChildData[achievementsCldSetKey] =
            setCldInfo[achievementsCldSetKey]
          break
      }
    })
  }

  return achievementsChildData
}

export const handleAchievementsConvertHankakuToZenkaku = (
  targetObj: any,
  convertKeyArray: string[] = ['remarks', 'absenceSupport', 'visitRemarks']
) => {
  convertKeyArray.forEach((convertKey: string) => {
    if (targetObj[convertKey]) {
      targetObj[convertKey] = moji(targetObj[convertKey])
        .convert('HE', 'ZE')
        .convert('HK', 'ZK')
        .toString()
    }
  })
}

export const handleCheckDupDayAchivementsArray = (
  achievementsArray: { [key: string]: any }[],
  errorMsgArray: {
    errMsg: string
    year: number
    month: number
    day: number
  }[],
  isBillingListMode = false
) => {
  const dupDayAchivementsArray = achievementsArray.filter(
    (achievements: any) =>
      achievementsArray.filter(
        (checkAchievementsArray: any) =>
          achievements.day === checkAchievementsArray.day
      ).length > 1
  )

  if (isBillingListMode) {
    if (dupDayAchivementsArray.length > 0) {
      return true
    } else {
      return false
    }
  }

  let dupDayErrorAchivementsArray = dupDayAchivementsArray.map(
    (achievements: any) => {
      return `${achievements.year}-${achievements.month}-${achievements.day}`
    }
  )

  dupDayErrorAchivementsArray = Array.from(new Set(dupDayErrorAchivementsArray))

  for (let index = 0; index < dupDayErrorAchivementsArray.length; index++) {
    const year = dupDayErrorAchivementsArray[index].split('-')[0]
    const month = dupDayErrorAchivementsArray[index].split('-')[1]
    const day = dupDayErrorAchivementsArray[index].split('-')[2]

    errorMsgArray.push({
      year: Number(year),
      month: Number(month),
      day: Number(day),
      errMsg: `${handleCurrentJapaneseCalendar(
        Number(year),
        Number(month)
      )}${Number(day)}日の実績が重複しています。`,
    })
  }
}

export const handleCheckCountConsultationAddition = (
  achievementsArray: { [key: string]: any }[],
  errorMsgArray: {
    errMsg: string
    year: number
    month: number
    day: number
  }[],
  isBillingListMode = false
) => {
  let KeyPrefix = ''

  if (achievementsArray[0] && achievementsArray[0].affiliation === '1') {
    KeyPrefix = 'jihatsu_'
  }

  const consultationAdditionArray = achievementsArray.filter(
    (achievements: any) =>
      achievements[KeyPrefix + 'consultation_addition'] === 1
  )

  if (consultationAdditionArray.length > 1) {
    for (let index = 0; index < consultationAdditionArray.length; index++) {
      errorMsgArray.push({
        year: Number(consultationAdditionArray[index].year),
        month: Number(consultationAdditionArray[index].month),
        day: Number(consultationAdditionArray[index].day),
        errMsg: `${handleCurrentJapaneseCalendar(
          consultationAdditionArray[index].year,
          Number(consultationAdditionArray[index].month)
        )}${
          consultationAdditionArray[index].day
        }日の実績の事業所内相談加算Ⅰを修正してください。事業所内相談加算Ⅰは月1回までです。`,
      })
    }
  }

  const consultationAddition2Array = achievementsArray.filter(
    (achievements: any) =>
      achievements[KeyPrefix + 'consultation_addition2'] === 1
  )

  if (consultationAddition2Array.length > 1) {
    for (let index = 0; index < consultationAddition2Array.length; index++) {
      errorMsgArray.push({
        year: Number(consultationAddition2Array[index].year),
        month: Number(consultationAddition2Array[index].month),
        day: Number(consultationAddition2Array[index].day),
        errMsg: `${handleCurrentJapaneseCalendar(
          consultationAddition2Array[index].year,
          Number(consultationAddition2Array[index].month)
        )}${
          consultationAddition2Array[index].day
        }日の実績の事業所内相談加算Ⅱを修正してください。事業所内相談加算Ⅱは月1回までです。`,
      })
    }
  }

  if (isBillingListMode) {
    if (
      consultationAdditionArray.length > 1 ||
      consultationAddition2Array.length > 1
    ) {
      return true
    } else {
      return false
    }
  }
}

export const handleCheckDiffCldObjAffiliationAndAchievementsTargetAffiliation = (
  cldObj: {
    affiliation: string
    visitChildFlg: string
  },
  targetAffiliation: string
) => {
  switch (targetAffiliation) {
    case '2':
      if (cldObj.visitChildFlg !== '1') {
        return true
      } else {
        return false
      }

    default:
      if (cldObj.affiliation !== targetAffiliation) {
        return true
      } else {
        return false
      }
  }
}

export const handleCheckDiffCldObjAffiliationAndAchievementsAffiliationByVisit = (
  achievementsArray: ResponseVisitAchievementsType[],
  cldObj: {
    visitChildFlg: string
  },
  errorMsgArray: {
    errMsg: string
    year: number
    month: number
    day: number
  }[],
  isBillingListMode = false,
  isCsvReBilling = false
) => {
  const isDiff = !achievementsArray.every(
    (achievements: ResponseVisitAchievementsType) =>
      cldObj?.visitChildFlg === '1' && achievements.affiliation === '2'
  )

  if (isDiff) {
    errorMsgArray.push({
      year: 0,
      month: 0,
      day: 0,
      errMsg: isCsvReBilling
        ? '児童情報の所属と実績記録の所属が異なります。児童情報を正しい所属に変更するか、該当の実績記録を削除してください。'
        : '児童情報の所属と実績記録の所属が異なります。児童情報または連絡帳で正しい所属に変更してください。',
    })
  }

  if (isBillingListMode) {
    if (isDiff) {
      return true
    } else {
      return false
    }
  }
}

export const handleCheckDiffCldObjAffiliationAndAchievementsAffiliation = (
  achievementsArray: ResponseAchievementsType[],
  cldObj: {
    affiliation: string
  },
  errorMsgArray: {
    errMsg: string
    year: number
    month: number
    day: number
  }[],
  isBillingListMode = false,
  isCsvReBilling = false
) => {
  const isDiff = !achievementsArray.every(
    (achievements: ResponseAchievementsType) =>
      cldObj?.affiliation === achievements.affiliation
  )

  if (isDiff) {
    errorMsgArray.push({
      year: 0,
      month: 0,
      day: 0,
      errMsg: isCsvReBilling
        ? '児童情報の所属と実績記録の所属が異なります。児童情報を正しい所属に変更してください。（新たに別の所属で実績記録を作成する場合は現在の実績記録を全て削除してください。）'
        : '児童情報の所属と実績記録の所属が異なります。児童情報または連絡帳で正しい所属に変更してください。',
    })
  }

  if (isBillingListMode) {
    if (isDiff) {
      return true
    } else {
      return false
    }
  }
}

export const useAchievementsChild = () => {
  const handlePreSetAchievementsChildInfo = (
    latestCldCurrentInfo: ResponseCldInfoType,
    reBillingChildInfo: AchivementsCldInfoType | null,
    state: {
      cldCurrentInfo: ResponseCldInfoType | null
      isReBilling?: boolean
      fromYear: number | Date
      fromMonth: number | Date
    },
    year: number | Date,
    month: number | Date,
    officeData: OfficeInfoForAchivements
  ) => {
    let achievementsChildData: AchivementsCldInfoType = {
      /* eslint-disable */
      office_name: '',
      office_number: '',
      /* eslint-enable */
      year: state.fromYear,
      month: state.fromMonth,
    }

    if (!state.isReBilling) {
      // 正規請求は常に最新の児童情報を表示する
      state.cldCurrentInfo = latestCldCurrentInfo as ResponseCldInfoType

      achievementsChildData = handleUpdateAchievementsCldData(
        achievementsChildData,
        latestCldCurrentInfo
      )
    } else {
      // 再請求は再請求の児童情報
      state.cldCurrentInfo = reBillingChildInfo as ResponseCldInfoType &
        AchivementsCldInfoType

      achievementsChildData = handleUpdateAchievementsCldData(
        achievementsChildData,
        reBillingChildInfo
      )
    }

    if (officeData) {
      const officeNumber = handleGetCheckOfficeNumber(
        officeData.unit_flg,
        officeData.office_number
      )

      if (achievementsChildData) {
        /* eslint-disable */
        achievementsChildData.office_name = officeData.office_name
        achievementsChildData.office_number = officeNumber
        /* eslint-enable */

        achievementsChildData.year = achievementsChildData.year
          ? achievementsChildData.year
          : year

        achievementsChildData.month = achievementsChildData.month
          ? achievementsChildData.month
          : month
      }
    }

    return achievementsChildData
  }

  return {
    handlePreSetAchievementsChildInfo,
  }
}

export const useAchievementsTable = (
  context: SetupContext,
  props: {
    officeId: string
    isCsvReBilling: boolean
    officeBillingGroup: OfficeUnitsBillingGroupType[]
    isEdit: boolean
  }
) => {
  const handleOpenModal = (
    day: number,
    index: number,
    achievements: { id: string; officeId: string }
  ) => {
    if (!props.isEdit) {
      return
    }

    if (
      !props.isCsvReBilling &&
      achievements &&
      achievements.id &&
      achievements.officeId !== props.officeId
    ) {
      alert(
        'この実績記録は他の単位の事業所で作成されているため、この事業所では編集できません。\n実績記録を作成した事業所のアカウントに切り替えて編集してください。'
      )
      return
    }

    context.emit('open-modal', day, index)
  }

  const handleLoadImg = (achievementsId: string) => {
    context.emit('img-load', achievementsId)
  }

  const handleGetAchivementsOfficeUnits = (achievements: any) => {
    let officeUnitsText = ''

    if (
      !props.isCsvReBilling &&
      achievements &&
      (achievements as { id: string; officeId: string }).id &&
      (achievements as { id: string; officeId: string }).officeId !==
        props.officeId
    ) {
      const targetOfficeUnitsBillingGroup = props.officeBillingGroup.find(
        (officeUnitsBillingGroup: OfficeUnitsBillingGroupType) =>
          achievements.officeId === officeUnitsBillingGroup.office_id
      )

      if (targetOfficeUnitsBillingGroup) {
        officeUnitsText = `[単位${String(
          targetOfficeUnitsBillingGroup.office_number
        ).slice(-1)}]`
      }
    }

    return officeUnitsText
  }

  return {
    handleLoadImg,
    handleOpenModal,
    handleGetAchivementsOfficeUnits,
  }
}

export const handleGetWaitingTime = (
  cldbookRecordCount: number,
  cldbookRecordDeleteCount: number
) => {
  if (!cldbookRecordCount) {
    cldbookRecordCount = 0
  }

  if (!cldbookRecordDeleteCount) {
    cldbookRecordDeleteCount = 0
  }

  const totalUpdateTime = Number(cldbookRecordCount) * 4000

  const totalDeleteTime = Number(cldbookRecordDeleteCount) * 2000

  const totalTime = totalUpdateTime + totalDeleteTime

  const totalSec = Math.floor(totalTime / 1000) % 60

  const totalMinutes = Math.floor(totalTime / 60000)

  return [totalTime, totalSec, totalMinutes]
}

export const handlePostedAchivementsUpdateError = (
  meta: string,
  day = '',
  isVisitMode = false
) => {
  const isVisitModeText = isVisitMode
    ? '同日の児童発達または放デイの実績記録の'
    : ''

  switch (meta) {
    case '2805':
    case '2834':
      alert(
        `事業所内相談支援加算Iが、今月の${day}日にすでに記録されています。この実績記録を保存したい場合は${isVisitModeText}事業所内相談支援加算Iを未選択で保存するか、連絡帳または実績記録まとめて作成・編集にて、${day}日の事業所内相談支援加算Iを未選択で保存してください。`
      )
      break

    case '2806':
    case '2835':
      alert(
        `事業所内相談支援加算IIが、今月の${day}日にすでに記録されています。この実績記録を保存したい場合は${isVisitModeText}事業所内相談支援加算IIを未選択で保存するか、連絡帳または実績記録まとめて作成・編集にて、${day}日の事業所内相談支援加算Iを未選択で保存してください。`
      )
      break

    case '2836':
      alert(
        `すでに所属の異なる同日の児童発達または放デイの実績記録が存在しているため、実績記録を新規作成・編集することはできません。${
          isVisitMode
            ? '同日の連絡帳から実績記録を新規作成・編集できます。'
            : '同日の連絡帳または実績記録まとめて作成・編集にて、所属を変更することで実績記録を新規作成・編集できます。'
        }`
      )
      break

    case '2701':
      alert(
        `すでに該当する実績記録または連絡帳が削除されているため、実績を新規作成・編集することはできません。`
      )
      break

    default:
      alert(`実績記録を保存できません。エラーコード[${meta}]`)
      break
  }
}

export const useAchievementsPage = (state: {
  cldCurrentInfo: AchivementsCldInfoType | null
  targetAchievementsArray: ResponseAchievementsType[]
  targetVisitAchievementsArray: ResponseVisitAchievementsType[]
  isAchievementsErrMsg: boolean
  isVisitAchievementsErrMsg: boolean
  isAchievementsShow: boolean
  isVisitAchievementsShow: boolean
  activeTabAffiliation: string
}) => {
  const handleSetAchivementsData = (
    targetAchievementsArray: ResponseAchievementsType[],
    isAchievementsErrMsg: boolean,
    cldCurrentInfo: AchivementsCldInfoType
  ) => {
    state.targetAchievementsArray.splice(
      0,
      state.targetAchievementsArray.length
    )

    state.targetAchievementsArray = targetAchievementsArray
    state.isAchievementsErrMsg = isAchievementsErrMsg
    state.cldCurrentInfo = cldCurrentInfo

    state.isAchievementsShow = true
  }

  const handleSetVisitAchivementsData = (
    targetVisitAchievementsArray: ResponseVisitAchievementsType[],
    isVisitAchievementsErrMsg: boolean,
    cldCurrentInfo: AchivementsCldInfoType
  ) => {
    state.targetVisitAchievementsArray.splice(
      0,
      state.targetVisitAchievementsArray.length
    )

    state.targetVisitAchievementsArray = targetVisitAchievementsArray
    state.isVisitAchievementsErrMsg = isVisitAchievementsErrMsg
    state.cldCurrentInfo = cldCurrentInfo

    state.isVisitAchievementsShow = true
  }

  const handleTabSwitch = (setAffiliation: string) => {
    state.activeTabAffiliation = setAffiliation
    sessionStorageUtils.handleSetSessionStorage(
      'cldAchivementsActiveAffiliation',
      state.activeTabAffiliation
    )
  }

  return {
    handleSetAchivementsData,
    handleSetVisitAchivementsData,
    handleTabSwitch,
  }
}

// 通所実績記録の初期化
export const handleResetAchievementsValue = (state: any) => {
  const resetKeyArray = []
  for (let index = 0; index < defineObject['ACHIVEMENTS_KASAN_DEFAULT_ARRAY'].length; index++) {
    let camelPrefix = ''
    let setKey = defineObject['ACHIVEMENTS_KASAN_DEFAULT_ARRAY'][index].key as string
    const value = defineObject['ACHIVEMENTS_KASAN_DEFAULT_ARRAY'][index].value
    if (state.noteDeleteParam.dataObject.affiliation === '1') {
      camelPrefix = 'jihatsu'
      setKey = `${setKey.charAt(0).toUpperCase()}${setKey.slice(1)}`
    }
    resetKeyArray.push({
      key: `${camelPrefix}${setKey}`,
      value: value
    })
  }
  for (let index = 0; index < defineObject['ACHIVEMENTS_REVISION_2024_KASAN_DEFAULT_ARRAY'].length; index++) {
    let camelPrefix = ''
    let setKey = defineObject['ACHIVEMENTS_REVISION_2024_KASAN_DEFAULT_ARRAY'][index].key as string
    const value = defineObject['ACHIVEMENTS_REVISION_2024_KASAN_DEFAULT_ARRAY'][index].value
    if (state.noteDeleteParam.dataObject.affiliation === '1') {
      camelPrefix = 'jihatsu'
      setKey = `${setKey.charAt(0).toUpperCase()}${setKey.slice(1)}`
    }
    resetKeyArray.push({
      key: `${camelPrefix}${setKey}`,
      value: value
    })
  }
  resetKeyArray.push(... defineObject['ACHIVEMENTS_DEFAULT_ARRAY'])
  resetKeyArray.forEach(el => {
    state.noteDeleteParam.dataObject[el.key] = el.value
  })
}

// 保訪実績記録の初期化
export const handleResetVisitAchievementsValue = (state: any) => {
  defineObject['ACHIVEMENTS_VISIT_KASAN_DEFAULT_ARRAY'].forEach(el => {
    state.noteDeleteParam.dataObject[el.key] = el.value
  })
  defineObject['ACHIVEMENTS_REVISION_2024_VISIT_KASAN_DEFAULT_ARRAY'].forEach(el => {
    state.noteDeleteParam.dataObject[el.key] = el.value
  })
}

